/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date custom scalar type - handles both Date objects and ISO strings */
  Date: { input: string; output: string; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: Record<string, unknown>; output: Record<string, unknown>; }
};

export type AddBankAccountFailure = DomainError & {
  __typename?: 'AddBankAccountFailure';
  /** Machine-readable failure category. Stable across releases. */
  code: AddBankAccountFailureCode;
  /** User-facing message. Safe to display directly. */
  message: Scalars['String']['output'];
};

/** Machine-readable failure category for `addBankAccount`. Stable across releases. No real members today — the mutation has no domain-decline path; the enum is kept as a stable slot for future declines. */
export type AddBankAccountFailureCode =
  | 'RESERVED';

/** Input for `addBankAccount`. Contains only the tokenized ACH metadata from Step 1 — the raw account and routing numbers never appear here. */
export type AddBankAccountInput = {
  /** Account type — CHECKING | SAVINGS | OTHER. */
  accountType: BankAccountType;
  /** Authorization transaction ID from `verifyBankAccountInformation`. */
  authTransactionId: Scalars['String']['input'];
  /** Bank name. Persisted to `ACHBankName__c`. */
  bankName: Scalars['String']['input'];
  /** Optional billing-address override for the saved account. Omit to leave blank — the read side then falls back to the member's Contact address. */
  billingAddress?: InputMaybe<BillingAddressInput>;
  /** Token ID from `verifyBankAccountInformation`. Opaque to the caller. */
  gatewayTokenId: Scalars['String']['input'];
  /** True if this is an HSA account. Persisted to `HSACard__c`. */
  hsa: Scalars['Boolean']['input'];
  /** True to make this the member's default payment method. Salesforce Flow atomically demotes the prior default. */
  isDefault: Scalars['Boolean']['input'];
  /** Last 5–6 digits of the account number, as a numeric string (e.g. `"123456"`). The full account number never appears here. */
  last6: Scalars['String']['input'];
  /** Name on the bank account. Persisted to `Name_on_Card__c`. */
  nameOnAccount: Scalars['String']['input'];
  /** The 9-digit ABA routing number (public bank data, not NPI). */
  routingLast9: Scalars['String']['input'];
  /** Source URL that originated the request. Max 500 characters. */
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  /** Web/MD domain that originated the request. Max 100 characters. */
  webMdDomain?: InputMaybe<Scalars['String']['input']>;
};

/** Typed outcome of `addBankAccount` — Success on persisted account. Infrastructure and caller errors surface as GraphQL `errors`, not as result variants. The Failure variant exists as a stable slot for future domain declines. */
export type AddBankAccountResult = AddBankAccountFailure | AddBankAccountSuccess;

/** Successful outcome of `addBankAccount`. Carries the persisted account as it now lives in Salesforce. */
export type AddBankAccountSuccess = {
  __typename?: 'AddBankAccountSuccess';
  /** The persisted `Payment_Profile__c` row mapped to the domain `SavedBankAccount` shape. */
  account: SavedBankAccount;
};

export type AddCreditCardFailure = DomainError & {
  __typename?: 'AddCreditCardFailure';
  /** Machine-readable failure category. Stable across releases. */
  code: AddCreditCardFailureCode;
  /** User-facing message. Safe to display directly. */
  message: Scalars['String']['output'];
};

/** Machine-readable failure category for `addCreditCard`. Stable across releases. No real members today — the mutation has no domain-decline path; the enum is kept as a stable slot for future declines. */
export type AddCreditCardFailureCode =
  | 'RESERVED';

/** Input for `addCreditCard`. Contains only the tokenized card metadata from Step 1 — the PAN and CVV never appear here. */
export type AddCreditCardInput = {
  /** Optional affluence classification pass-through. */
  affluence?: InputMaybe<Scalars['String']['input']>;
  /** Authorization transaction ID from `verifyCreditCardInformation`. */
  authTransactionId: Scalars['String']['input'];
  /** Optional billing-address override for the saved card. Omit to leave blank — the read side then falls back to the member's Contact address. */
  billingAddress?: InputMaybe<BillingAddressInput>;
  /** Card-type classification (COMMERCIAL | CONSUMER | UNKNOWN). Distinct from network. */
  cardType: CardType;
  /** Optional client-provided expiration marker (pass-through to `Expired__c`). */
  expired?: InputMaybe<Scalars['String']['input']>;
  /** Expiration month, 1–12. */
  expiryMonth: Scalars['Int']['input'];
  /** Expiration year as a 4-digit year (e.g. 2027). Combined with expiryMonth, the expiration must be in the current month or later. */
  expiryYear: Scalars['Int']['input'];
  /** Token ID from `verifyCreditCardInformation`. Opaque to the caller. */
  gatewayTokenId: Scalars['String']['input'];
  /** True if this card is HSA. Persisted to `HSACard__c`. */
  hsa: Scalars['Boolean']['input'];
  /** True to make this the member's default payment method. Salesforce Flow atomically demotes the prior default. */
  isDefault: Scalars['Boolean']['input'];
  /** Issuer country code — pass-through into `Issuer_Country__c`. */
  issuerCountry?: InputMaybe<Scalars['String']['input']>;
  /** Last 4 digits of the card PAN, as a 4-character numeric string (e.g. `"1234"`). */
  last4: Scalars['String']['input'];
  /** Cardholder name as printed on the card. */
  nameOnCard?: InputMaybe<Scalars['String']['input']>;
  /** Card network — AMEX | VISA | MC | DISC. */
  network: CardNetwork;
  /** Optional prepaid-type classification pass-through. */
  prePaidType?: InputMaybe<Scalars['String']['input']>;
  /** Source URL that originated the request. Max 500 characters. */
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  /** Web/MD domain that originated the request. Max 100 characters. */
  webMdDomain?: InputMaybe<Scalars['String']['input']>;
};

/** Typed outcome of `addCreditCard` — Success on persisted card. Infrastructure and caller errors surface as GraphQL `errors`, not as result variants. The Failure variant exists as a stable slot for future domain declines. */
export type AddCreditCardResult = AddCreditCardFailure | AddCreditCardSuccess;

/** Successful outcome of `addCreditCard`. Carries the persisted card as it now lives in Salesforce. */
export type AddCreditCardSuccess = {
  __typename?: 'AddCreditCardSuccess';
  /** The persisted `Payment_Profile__c` row mapped to the domain `SavedCreditCard` shape. */
  card: SavedCreditCard;
};

/** Entity to save to one of the caller's lists. */
export type AddMyBookmarkInput = {
  /** Opaque id of the entity item to save. */
  entityId: Scalars['String']['input'];
  /** The type of entity being saved. */
  entityType: BookmarkEntityType;
  /** Which list to save it to. */
  kind: BookmarkKind;
};

/** A nutrition article's browse/card fields. Every role reads the same catalog. */
export type Article = {
  __typename?: 'Article';
  /** Author attribution. */
  author?: Maybe<Scalars['String']['output']>;
  /** Article body as vendor-authored HTML, UNSANITIZED — the client must sanitize before rendering. */
  body?: Maybe<Scalars['String']['output']>;
  /** Food-and-nutrition (Article Type) taxonomy terms. */
  foodNutrition: Array<Scalars['String']['output']>;
  /** Health-and-wellness (Topic) taxonomy terms. */
  healthWellness: Array<Scalars['String']['output']>;
  /** The vendor's own stable item id: this article's external identity. */
  id: Scalars['ID']['output'];
  /** Time-limited read URL for the article's image, or null when it has none or it cannot be signed. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  isBookmarked: Scalars['Boolean']['output'];
  /** Shorter teaser for compact cards. */
  miniTeaser?: Maybe<Scalars['String']['output']>;
  /** Article subtitle. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Short teaser text. */
  teaser?: Maybe<Scalars['String']['output']>;
  /** Article title. */
  title: Scalars['String']['output'];
  /** Weight-management taxonomy terms. Not filterable. */
  weightManagement: Array<Scalars['String']['output']>;
};

/** One vocabulary's term counts. Self-excluding: this vocabulary's own active selection is ignored when computing its counts, but every other active filter/search still applies. */
export type ArticleFacetGroup = {
  __typename?: 'ArticleFacetGroup';
  /** Every term still reachable under the request's other active filters, count descending. */
  values: Array<ArticleFacetValue>;
  /** Which vocabulary these counts belong to. */
  vocabulary: ArticleTaxonomyVocabulary;
};

/** One taxonomy term and how many articles currently match it. */
export type ArticleFacetValue = {
  __typename?: 'ArticleFacetValue';
  /** Articles carrying this term, under the request's other filters. */
  count: Scalars['Int']['output'];
  /** The taxonomy term, e.g. "Heart Health". */
  term: Scalars['String']['output'];
};

/** Filter and search options for `articleFacets`. No pagination. */
export type ArticleFacetsInput = {
  /** Article Type filter: match ANY of these food-and-nutrition terms. */
  foodNutrition?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Topic filter: match ANY of these health-and-wellness terms. */
  healthWellness?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Free-text search over title/teaser/author/body. Understands quoted phrases and -exclusion. */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** A taxonomy vocabulary articles can be filtered and faceted by. */
export type ArticleTaxonomyVocabulary =
  | 'FOOD_NUTRITION'
  | 'HEALTH_WELLNESS';

/** Filter, search, and pagination options for `articles`. */
export type ArticlesInput = {
  /** When true, return only articles the caller has bookmarked. */
  bookmarkedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Article Type filter: match ANY of these food-and-nutrition terms. */
  foodNutrition?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Topic filter: match ANY of these health-and-wellness terms. */
  healthWellness?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Pagination: max records to return. Defaults to 20, hard ceiling 100. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Pagination: records to skip. Defaults to 0. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Free-text search over title/teaser/author/body. Understands quoted phrases and -exclusion. */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** A page of articles matching `ArticlesInput`. */
export type ArticlesSuccess = {
  __typename?: 'ArticlesSuccess';
  /** Articles in this page, ordered per the query. */
  edges: Array<Article>;
  /** Articles in this page's `edges`. Equal to `edges.length`. */
  filteredCount: Scalars['Int']['output'];
  /** Echoed `limit` from the request. */
  limit: Scalars['Int']['output'];
  /** Echoed `offset` from the request. */
  offset: Scalars['Int']['output'];
  /** Total articles matching this request's filter/search/bookmarkedOnly, unbounded by `limit`/`offset`. Reliable pagination stop condition: `offset + limit >= totalCount`; do NOT use `edges.length < limit`. */
  totalCount: Scalars['Int']['output'];
};

/** The authenticated member's Annual Wellness Program exam status. All fields are null when no AWP exam is on record. */
export type AwpStatus = {
  __typename?: 'AwpStatus';
  /** Date of the member's last completed AWP exam (yyyy-MM-dd); null if the member has never completed one. */
  lastAwpDate?: Maybe<Scalars['String']['output']>;
  /** Date the next AWP exam is due (yyyy-MM-dd); null when lastAwpDate is null. */
  nextAwpDueDate?: Maybe<Scalars['String']['output']>;
  /** true when nextAwpDueDate is calculated (lastAwpDate + 1 year + 1 day) rather than stored; null when nextAwpDueDate is null. */
  nextAwpDueIsCalculated?: Maybe<Scalars['Boolean']['output']>;
};

/** One of the authenticated member's Annual Wellness Program visits. */
export type AwpVisit = {
  __typename?: 'AwpVisit';
  /** Date of the AWP exam (yyyy-MM-dd), used to identify the visit. */
  appointmentDate: Scalars['String']['output'];
};

/** Payment-method type returned by the FIS gateway for a tokenized bank account. */
export type BankAccountPaymentType =
  | 'ACH';

/** Bank-account type — CHECKING | SAVINGS | OTHER. Persisted to the SF `ACH_Name_of_Account__c` picklist. */
export type BankAccountType =
  | 'CHECKING'
  | 'OTHER'
  | 'SAVINGS';

/** Billing address composite. Returned as null if every underlying address field on the profile is blank. */
export type BillingAddress = {
  __typename?: 'BillingAddress';
  /** City. */
  city?: Maybe<Scalars['String']['output']>;
  /** Country of card issuance (from SF Issuer_Country__c). */
  country?: Maybe<Scalars['String']['output']>;
  /** Address line 1 (street). */
  line1?: Maybe<Scalars['String']['output']>;
  /** Address line 2 (apt, suite, etc.). */
  line2?: Maybe<Scalars['String']['output']>;
  /** State / region. */
  state?: Maybe<Scalars['String']['output']>;
  /** Postal / ZIP code. */
  zip?: Maybe<Scalars['String']['output']>;
};

/** Optional billing-address override for the saved card. When omitted, the SF address columns are left blank on create — the read side falls back to the member's Contact address at query time. */
export type BillingAddressInput = {
  /** City. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Country. */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Address line 1 (street). */
  line1?: InputMaybe<Scalars['String']['input']>;
  /** Address line 2 (apt, suite, etc.). */
  line2?: InputMaybe<Scalars['String']['input']>;
  /** State / region. */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Postal / ZIP code. */
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** A member's saved reference to a piece of entity data. Carries a pointer only — never the entity's own data. Resolving `entityId` back into a real record is the consuming feature's job. */
export type Bookmark = {
  __typename?: 'Bookmark';
  /** When the member first saved this entity. */
  createdAt: Scalars['Date']['output'];
  /** Opaque id of the bookmarked entity. NOT the platform's `entityId` (which identifies a client application) — this names a row in an entity table. */
  entityId: Scalars['String']['output'];
  /** The type of entity saved. */
  entityType: BookmarkEntityType;
  /** Which list this save belongs to. */
  kind: BookmarkKind;
};

/** A type of entity that can be saved. Additive — new values ship without a schema migration. */
export type BookmarkEntityType =
  | 'NUTRITION_ARTICLE'
  | 'NUTRITION_RECIPE'
  | 'WELLNESS_ARTICLE';

/** Which list a save belongs to. One value today; the schema supports an entity being in several lists independently, so further kinds are additive and non-breaking. */
export type BookmarkKind =
  | 'BOOKMARK';

export type CancelUpcomingPaymentFailure = DomainError & {
  __typename?: 'CancelUpcomingPaymentFailure';
  /** Machine-readable failure category. Stable across releases. */
  code: CancelUpcomingPaymentFailureCode;
  /** User-facing message. Safe to display directly. */
  message: Scalars['String']['output'];
};

/** Machine-readable failure category for `cancelUpcomingPayment`. Stable across releases — drives client dispatch. */
export type CancelUpcomingPaymentFailureCode =
  | 'NOT_FOUND';

/** Input for `cancelUpcomingPayment` — cancels a scheduled one-time payment. */
export type CancelUpcomingPaymentInput = {
  /** Salesforce `Transaction_Queue__c` record ID of the upcoming payment to cancel. Must belong to the authenticated member and still be in an upcoming (cancellable) state. */
  id: Scalars['ID']['input'];
};

/** Typed outcome of `cancelUpcomingPayment` — Success on the cancelled record's id, Failure on domain-level rejection (`NOT_FOUND`). Infrastructure and caller errors — including Zod validation failures — surface as GraphQL `errors`, not as result variants. */
export type CancelUpcomingPaymentResult = CancelUpcomingPaymentFailure | CancelUpcomingPaymentSuccess;

/** Successful outcome of `cancelUpcomingPayment`. Carries only the id of the cancelled `Transaction_Queue__c` record — the row stops appearing in `myUpcomingPayments` on the next read. */
export type CancelUpcomingPaymentSuccess = {
  __typename?: 'CancelUpcomingPaymentSuccess';
  /** The cancelled `Transaction_Queue__c` record's id. */
  id: Scalars['ID']['output'];
};

/** Supported credit-card networks returned by the FIS payment gateway. */
export type CardNetwork =
  | 'AMEX'
  | 'DISC'
  | 'MC'
  | 'VISA';

/** Card-type classification, distinct from network. `COMMERCIAL` / `CONSUMER` / `UNKNOWN`. Sourced from the gateway verify response. */
export type CardType =
  | 'COMMERCIAL'
  | 'CONSUMER'
  | 'UNKNOWN';

/** A Contact Us support-request category. */
export type ContactUsCategoryType = {
  __typename?: 'ContactUsCategoryType';
  /** Success line shown after a confirmed cancellation. Non-null only for the cancellation category. */
  cancellationSuccessLine?: Maybe<Scalars['String']['output']>;
  /** Body of the 'are you sure?' confirmation the client must show before submitting. Non-null only for the cancellation category; a null value means no confirmation step. */
  cancellationWarning?: Maybe<Scalars['String']['output']>;
  /** Stable identifier. Pass this back as `categoryKey` when submitting. */
  key: Scalars['String']['output'];
  /** Dropdown label. */
  label: Scalars['String']['output'];
  /** Display order, ascending. */
  sortOrder: Scalars['Int']['output'];
  /** Category-specific line shown in the on-screen success dialog. */
  successMiddleLine: Scalars['String']['output'];
};

export type DismissNotificationFailure = DomainError & {
  __typename?: 'DismissNotificationFailure';
  /** Machine-readable failure category. Stable across releases. */
  code: DismissNotificationFailureCode;
  /** User-facing message. Safe to display directly. */
  message: Scalars['String']['output'];
};

/** Machine-readable failure category for `dismissNotification`. */
export type DismissNotificationFailureCode =
  | 'NOTIFICATION_NOT_DISMISSIBLE'
  | 'UNKNOWN_NOTIFICATION_ID';

/** Input for `dismissNotification`. */
export type DismissNotificationInput = {
  /** Server-assigned notification row id to dismiss. */
  notificationId: Scalars['ID']['input'];
};

/** Typed outcome of `dismissNotification` — Success (including a no-op repeat dismiss), or Failure when the id is unknown/not owned, or the notification's type is not dismissible. */
export type DismissNotificationResult = DismissNotificationFailure | DismissNotificationSuccess;

/** Successful outcome of `dismissNotification`. */
export type DismissNotificationSuccess = {
  __typename?: 'DismissNotificationSuccess';
  success: Scalars['Boolean']['output'];
};

/** Common shape for typed domain-level failure variants in mutation results. Implementing types add their own typed `code` enum. */
export type DomainError = {
  /** User-facing message. Safe to display directly. */
  message: Scalars['String']['output'];
};

export type DownloadPaymentReceiptFailure = DomainError & {
  __typename?: 'DownloadPaymentReceiptFailure';
  /** Machine-readable failure category. Stable across releases. */
  code: DownloadPaymentReceiptFailureCode;
  /** User-facing message. Safe to display directly. */
  message: Scalars['String']['output'];
};

/** Machine-readable failure category for `downloadPaymentReceipt`. Stable across releases — drives client dispatch. */
export type DownloadPaymentReceiptFailureCode =
  | 'FAILED'
  | 'NOT_FOUND';

/** Typed outcome of `downloadPaymentReceipt` — Success on the receipt document, Failure on domain-level rejection (`NOT_FOUND`, `FAILED`). Infrastructure and caller errors surface as GraphQL `errors`, not as result variants. */
export type DownloadPaymentReceiptResult = DownloadPaymentReceiptFailure | DownloadPaymentReceiptSuccess;

/** Successful outcome of `downloadPaymentReceipt`. Carries the receipt PDF as base64 exactly as Apex returned it. */
export type DownloadPaymentReceiptSuccess = {
  __typename?: 'DownloadPaymentReceiptSuccess';
  /** Base64-encoded receipt PDF, returned exactly as Apex produced it. */
  document: Scalars['String']['output'];
  /** Receipt filename, returned exactly as Apex produced it. */
  filename: Scalars['String']['output'];
};

export type EditBankAccountFailure = DomainError & {
  __typename?: 'EditBankAccountFailure';
  /** Machine-readable failure category. Stable across releases. */
  code: EditBankAccountFailureCode;
  /** User-facing message. Safe to display directly. */
  message: Scalars['String']['output'];
};

/** Machine-readable failure category for `editBankAccount`. Stable across releases — drives client dispatch. */
export type EditBankAccountFailureCode =
  | 'NOT_FOUND';

/** Input for `editBankAccount`. Every field optional — send only what you want to change. Routing / account digits and the gateway token are immutable and deliberately absent. */
export type EditBankAccountInput = {
  /** Account type — CHECKING | SAVINGS | OTHER. Persisted to `ACH_Name_of_Account__c`. */
  accountType?: InputMaybe<BankAccountType>;
  /** Bank name. Persisted to `ACHBankName__c`. */
  bankName?: InputMaybe<Scalars['String']['input']>;
  /** Optional billing-address override. When present, each sub-field is individually optional; omitted sub-fields leave that column unchanged in Salesforce. */
  billingAddress?: InputMaybe<BillingAddressInput>;
  /** True if this is an HSA account. Persisted to `HSACard__c`. */
  hsa?: InputMaybe<Scalars['Boolean']['input']>;
  /** True to make this the member's default payment method. Salesforce Flow atomically demotes the prior default. */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name on the bank account. Persisted to `Name_on_Card__c`. */
  nameOnAccount?: InputMaybe<Scalars['String']['input']>;
};

/** Typed outcome of `editBankAccount` — Success on updated account, Failure on domain-level rejection (`NOT_FOUND`). Infrastructure and caller errors — including Zod validation failures — surface as GraphQL `errors`, not as result variants. */
export type EditBankAccountResult = EditBankAccountFailure | EditBankAccountSuccess;

/** Successful outcome of `editBankAccount`. Carries the updated account as it now lives in Salesforce after the PATCH + re-read. */
export type EditBankAccountSuccess = {
  __typename?: 'EditBankAccountSuccess';
  /** The updated `Payment_Profile__c` row mapped to the domain `SavedBankAccount` shape. */
  account: SavedBankAccount;
};

export type EditCreditCardFailure = DomainError & {
  __typename?: 'EditCreditCardFailure';
  /** Machine-readable failure category. Stable across releases. */
  code: EditCreditCardFailureCode;
  /** User-facing message. Safe to display directly. */
  message: Scalars['String']['output'];
};

/** Machine-readable failure category for `editCreditCard`. Stable across releases — drives client dispatch. */
export type EditCreditCardFailureCode =
  | 'NOT_FOUND';

/** Input for `editCreditCard`. Every field optional — send only what you want to change. PAN, last-4, and gateway tokens are immutable and deliberately absent. */
export type EditCreditCardInput = {
  /** Optional affluence classification pass-through. */
  affluence?: InputMaybe<Scalars['String']['input']>;
  /** Optional billing-address override. When present, each sub-field is individually optional; omitted sub-fields leave that column unchanged in Salesforce. */
  billingAddress?: InputMaybe<BillingAddressInput>;
  /** Card-type classification (COMMERCIAL | CONSUMER | UNKNOWN). */
  cardType?: InputMaybe<CardType>;
  /** Optional client-provided expiration marker (pass-through to `Expired__c`). */
  expired?: InputMaybe<Scalars['String']['input']>;
  /** Expiration month, 1–12. Must be provided together with `expiryYear`; the combined date must be in the future. */
  expiryMonth?: InputMaybe<Scalars['Int']['input']>;
  /** Expiration year as a 4-digit year (e.g. 2027). Must be provided together with `expiryMonth`; the combined date must be in the future. */
  expiryYear?: InputMaybe<Scalars['Int']['input']>;
  /** True if this card is HSA. Persisted to `HSACard__c`. */
  hsa?: InputMaybe<Scalars['Boolean']['input']>;
  /** True to make this the member's default payment method. Salesforce Flow atomically demotes the prior default. */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Issuer country code — pass-through into `Issuer_Country__c`. */
  issuerCountry?: InputMaybe<Scalars['String']['input']>;
  /** Cardholder name as printed on the card. */
  nameOnCard?: InputMaybe<Scalars['String']['input']>;
  /** Optional prepaid-type classification pass-through. */
  prePaidType?: InputMaybe<Scalars['String']['input']>;
};

/** Typed outcome of `editCreditCard` — Success on updated card, Failure on domain-level rejection (`NOT_FOUND`). Infrastructure and caller errors — including Zod validation failures — surface as GraphQL `errors`, not as result variants. */
export type EditCreditCardResult = EditCreditCardFailure | EditCreditCardSuccess;

/** Successful outcome of `editCreditCard`. Carries the updated card as it now lives in Salesforce after the PATCH + re-read. */
export type EditCreditCardSuccess = {
  __typename?: 'EditCreditCardSuccess';
  /** The updated `Payment_Profile__c` row mapped to the domain `SavedCreditCard` shape. */
  card: SavedCreditCard;
};

export type EnableMyAutoPayFailure = DomainError & {
  __typename?: 'EnableMyAutoPayFailure';
  /** Machine-readable failure category. Stable across releases. */
  code: EnableMyAutoPayFailureCode;
  /** User-facing message. Safe to display directly. */
  message: Scalars['String']['output'];
};

/** Machine-readable failure category for `enableMyAutoPay`. Stable across releases — drives client dispatch. */
export type EnableMyAutoPayFailureCode =
  | 'ALREADY_ENABLED';

/** Typed outcome of `enableMyAutoPay` — Success on enrollment, Failure on domain-level rejection (`ALREADY_ENABLED`). Infrastructure and caller errors surface as GraphQL `errors`, not as result variants. */
export type EnableMyAutoPayResult = EnableMyAutoPayFailure | EnableMyAutoPaySuccess;

/** Successful outcome of `enableMyAutoPay`. Carries the caller's member record as read at the pre-check, with `autoPay` projected to `true` to reflect the write. */
export type EnableMyAutoPaySuccess = {
  __typename?: 'EnableMyAutoPaySuccess';
  /** The caller's own Member record from the pre-check read, with `autoPay` set to `true` to reflect the AutoPay__c write. */
  member: Member;
};

export type FitnessWidgetConfigType = {
  __typename?: 'FitnessWidgetConfigType';
  apiKey: Scalars['String']['output'];
  apiRootUrl: Scalars['String']['output'];
  debugMode: Scalars['Boolean']['output'];
  dialogBoxType: Scalars['String']['output'];
  headerElementClass: Scalars['String']['output'];
  masquerade: Scalars['Boolean']['output'];
  printedHandoutsUrl: Scalars['String']['output'];
  saveFavorites: Scalars['Boolean']['output'];
  secureMessaging: Scalars['Boolean']['output'];
  trainingMode: Scalars['Boolean']['output'];
  /** PTLinked vocabulary (e.g. "patient"), not our UserType enum. */
  userType: Scalars['String']['output'];
  userUid: Scalars['String']['output'];
};

export type FutureCancellationMemberDirectoryEntry = {
  __typename?: 'FutureCancellationMemberDirectoryEntry';
  /** Salesforce Account Id of the member's practice. */
  accountId?: Maybe<Scalars['String']['output']>;
  /** Computed age in years. */
  age?: Maybe<Scalars['Float']['output']>;
  /** Balance aged 1-30 days past due. */
  aging30?: Maybe<Scalars['Float']['output']>;
  /** Balance aged 31-60 days past due. */
  aging60?: Maybe<Scalars['Float']['output']>;
  /** Balance aged 61-90 days past due. */
  aging90?: Maybe<Scalars['Float']['output']>;
  /** Balance aged 91-120+ days past due. */
  aging120?: Maybe<Scalars['Float']['output']>;
  /** Current (not-yet-due) balance. */
  agingCurrent?: Maybe<Scalars['Float']['output']>;
  /** Membership MSRP amount. */
  amountMsrp?: Maybe<Scalars['Float']['output']>;
  /** Whether AutoPay is enabled. */
  autoPay?: Maybe<Scalars['Boolean']['output']>;
  /** Whether billing routes to a national account. */
  billToNationalAccount?: Maybe<Scalars['Boolean']['output']>;
  /** Number of days the balance is past due. */
  billingDaysPastDue?: Maybe<Scalars['Float']['output']>;
  /** Whether the member can be sent a secure message. Derived from a mailbox id that is never exposed raw; null on a read that did not select it. */
  canSendMessage?: Maybe<Scalars['Boolean']['output']>;
  /** Current agreement MSRP (annual fee). */
  currentAgreementMsrp?: Maybe<Scalars['Float']['output']>;
  /** Current agreement payment schedule. */
  currentAgreementPaymentSchedule?: Maybe<Scalars['String']['output']>;
  /** Current balance (formula field). */
  currentBalanceFormula?: Maybe<Scalars['Float']['output']>;
  /** Current membership type. */
  currentMembershipType?: Maybe<Scalars['String']['output']>;
  /** Date of birth (yyyy-MM-dd). */
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  /** Date of the oldest unpaid invoice (yyyy-MM-dd). */
  dateOfOldestUnpaidInvoice?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** Emergency contact phone number. */
  emergencyPhone?: Maybe<Scalars['String']['output']>;
  /** Employer name. */
  employer?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** Gender. */
  gender?: Maybe<Gender>;
  /** Salesforce Contact Id. */
  id: Scalars['ID']['output'];
  /** Insurance carrier name from the member's Insurance lookup — distinct from primaryInsurance, which is a separate free-text field. */
  insuranceName?: Maybe<Scalars['String']['output']>;
  isHealthChampion: Scalars['Boolean']['output'];
  /** Job title. */
  jobTitle?: Maybe<Scalars['String']['output']>;
  /** Date of the member's last wellness exam (yyyy-MM-dd). */
  lastAwpDate?: Maybe<Scalars['String']['output']>;
  /** Date recorded for the member's last cancellation. */
  lastCancelDate?: Maybe<Scalars['String']['output']>;
  /** Reason recorded for the member's last cancellation. */
  lastCancelReason?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** Amount of the member's last payment. */
  lastPaymentAmount?: Maybe<Scalars['Float']['output']>;
  /** Date of the member's last payment (yyyy-MM-dd). */
  lastPaymentDate?: Maybe<Scalars['String']['output']>;
  mailingAddress?: Maybe<PostalAddress>;
  /** MDVIP member Id. */
  mdvipId?: Maybe<Scalars['String']['output']>;
  /** Date the member's current membership was established (yyyy-MM-dd). */
  memberSince?: Maybe<Scalars['String']['output']>;
  /** Membership status. */
  memberStatus?: Maybe<Scalars['String']['output']>;
  /** Mobile phone number. */
  mobilePhone?: Maybe<Scalars['String']['output']>;
  /** Name of the corporate account billed for this member, if any. */
  nationalAccountName?: Maybe<Scalars['String']['output']>;
  /** Computed next-birthday date (yyyy-MM-dd). */
  nextBirthday?: Maybe<Scalars['String']['output']>;
  otherAddress?: Maybe<PostalAddress>;
  phone?: Maybe<Scalars['String']['output']>;
  /** Preferred method of communication. */
  preferredContactMethod?: Maybe<PreferredContactMethod>;
  /** Primary insurance company name. */
  primaryInsurance?: Maybe<Scalars['String']['output']>;
  /** SAS-signed URL for the member's profile photo, or null if a SAS could not be minted. When non-null, it always resolves to a URL whether or not a photo has been uploaded yet — a 404 on that URL is the no-photo signal. */
  profilePhotoUrl?: Maybe<ProfilePhotoUrl>;
  /** Computed membership renewal date (yyyy-MM-dd). */
  renewalDate?: Maybe<Scalars['String']['output']>;
  /** Salutation / title (e.g. Mr., Dr.). */
  salutation?: Maybe<Scalars['String']['output']>;
  /** Secondary insurance company name. */
  secondaryInsurance?: Maybe<Scalars['String']['output']>;
  /** Which servicing arrangement covers the member's membership. Resolved on the member's own read; null on reads that do not project it. */
  serviceState?: Maybe<MemberServiceState>;
  /** Work phone number. */
  workPhone?: Maybe<Scalars['String']['output']>;
};

/** Member gender — MALE | FEMALE. Maps to and from the Salesforce `Gender__c` picklist (`M` / `F`); reads as null when Salesforce holds no value or one outside this set. */
export type Gender =
  | 'FEMALE'
  | 'MALE';

/** One ingredient group. `name` is null for the vendor's unnamed/default group. */
export type IngredientGroup = {
  __typename?: 'IngredientGroup';
  /** Ingredient lines in this group, vendor text verbatim. */
  items: Array<Scalars['String']['output']>;
  /** Group heading, e.g. 'For the sauce'. */
  name?: Maybe<Scalars['String']['output']>;
};

export type IppeCalculationMemberDirectoryEntry = {
  __typename?: 'IppeCalculationMemberDirectoryEntry';
  /** Salesforce Account Id of the member's practice. */
  accountId?: Maybe<Scalars['String']['output']>;
  /** Computed age in years. */
  age?: Maybe<Scalars['Float']['output']>;
  /** Balance aged 1-30 days past due. */
  aging30?: Maybe<Scalars['Float']['output']>;
  /** Balance aged 31-60 days past due. */
  aging60?: Maybe<Scalars['Float']['output']>;
  /** Balance aged 61-90 days past due. */
  aging90?: Maybe<Scalars['Float']['output']>;
  /** Balance aged 91-120+ days past due. */
  aging120?: Maybe<Scalars['Float']['output']>;
  /** Current (not-yet-due) balance. */
  agingCurrent?: Maybe<Scalars['Float']['output']>;
  /** Membership MSRP amount. */
  amountMsrp?: Maybe<Scalars['Float']['output']>;
  /** Whether AutoPay is enabled. */
  autoPay?: Maybe<Scalars['Boolean']['output']>;
  /** Whether billing routes to a national account. */
  billToNationalAccount?: Maybe<Scalars['Boolean']['output']>;
  /** Number of days the balance is past due. */
  billingDaysPastDue?: Maybe<Scalars['Float']['output']>;
  /** Whether the member can be sent a secure message. Derived from a mailbox id that is never exposed raw; null on a read that did not select it. */
  canSendMessage?: Maybe<Scalars['Boolean']['output']>;
  /** Current agreement MSRP (annual fee). */
  currentAgreementMsrp?: Maybe<Scalars['Float']['output']>;
  /** Current agreement payment schedule. */
  currentAgreementPaymentSchedule?: Maybe<Scalars['String']['output']>;
  /** Current balance (formula field). */
  currentBalanceFormula?: Maybe<Scalars['Float']['output']>;
  /** Current membership type. */
  currentMembershipType?: Maybe<Scalars['String']['output']>;
  /** Date of birth (yyyy-MM-dd). */
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  /** Date of the oldest unpaid invoice (yyyy-MM-dd). */
  dateOfOldestUnpaidInvoice?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** Emergency contact phone number. */
  emergencyPhone?: Maybe<Scalars['String']['output']>;
  /** Employer name. */
  employer?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** Gender. */
  gender?: Maybe<Gender>;
  /** Salesforce Contact Id. */
  id: Scalars['ID']['output'];
  /** Insurance carrier name from the member's Insurance lookup — distinct from primaryInsurance, which is a separate free-text field. */
  insuranceName?: Maybe<Scalars['String']['output']>;
  isHealthChampion: Scalars['Boolean']['output'];
  /** Job title. */
  jobTitle?: Maybe<Scalars['String']['output']>;
  /** Date of the member's last wellness exam (yyyy-MM-dd). */
  lastAwpDate?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** Amount of the member's last payment. */
  lastPaymentAmount?: Maybe<Scalars['Float']['output']>;
  /** Date of the member's last payment (yyyy-MM-dd). */
  lastPaymentDate?: Maybe<Scalars['String']['output']>;
  mailingAddress?: Maybe<PostalAddress>;
  /** MDVIP member Id. */
  mdvipId?: Maybe<Scalars['String']['output']>;
  /** Date the member's current membership was established (yyyy-MM-dd). */
  memberSince?: Maybe<Scalars['String']['output']>;
  /** Membership status. */
  memberStatus?: Maybe<Scalars['String']['output']>;
  /** Mobile phone number. */
  mobilePhone?: Maybe<Scalars['String']['output']>;
  /** Name of the corporate account billed for this member, if any. */
  nationalAccountName?: Maybe<Scalars['String']['output']>;
  /** Computed next-birthday date (yyyy-MM-dd). */
  nextBirthday?: Maybe<Scalars['String']['output']>;
  otherAddress?: Maybe<PostalAddress>;
  phone?: Maybe<Scalars['String']['output']>;
  /** Preferred method of communication. */
  preferredContactMethod?: Maybe<PreferredContactMethod>;
  /** Primary insurance company name. */
  primaryInsurance?: Maybe<Scalars['String']['output']>;
  /** SAS-signed URL for the member's profile photo, or null if a SAS could not be minted. When non-null, it always resolves to a URL whether or not a photo has been uploaded yet — a 404 on that URL is the no-photo signal. */
  profilePhotoUrl?: Maybe<ProfilePhotoUrl>;
  /** Computed membership renewal date (yyyy-MM-dd). */
  renewalDate?: Maybe<Scalars['String']['output']>;
  /** Salutation / title (e.g. Mr., Dr.). */
  salutation?: Maybe<Scalars['String']['output']>;
  /** Secondary insurance company name. */
  secondaryInsurance?: Maybe<Scalars['String']['output']>;
  /** Which servicing arrangement covers the member's membership. Resolved on the member's own read; null on reads that do not project it. */
  serviceState?: Maybe<MemberServiceState>;
  /** End of the member's IPPE scheduling window: date of birth + 66 years (yyyy-MM-dd). null when date of birth is unknown. */
  suggestedEndDate?: Maybe<Scalars['String']['output']>;
  /** Start of the member's IPPE scheduling window: date of birth + 65 years (yyyy-MM-dd). null when date of birth is unknown. */
  suggestedStartDate?: Maybe<Scalars['String']['output']>;
  /** Work phone number. */
  workPhone?: Maybe<Scalars['String']['output']>;
};

/** Successful outcome of `markAllNotificationsAsRead`. */
export type MarkAllNotificationsAsReadSuccess = {
  __typename?: 'MarkAllNotificationsAsReadSuccess';
  success: Scalars['Boolean']['output'];
};

export type MarkNotificationAsReadFailure = DomainError & {
  __typename?: 'MarkNotificationAsReadFailure';
  /** Machine-readable failure category. Stable across releases. */
  code: MarkNotificationAsReadFailureCode;
  /** User-facing message. Safe to display directly. */
  message: Scalars['String']['output'];
};

/** Machine-readable failure category for `markNotificationAsRead`. */
export type MarkNotificationAsReadFailureCode =
  | 'UNKNOWN_NOTIFICATION_ID';

/** Input for `markNotificationAsRead`. */
export type MarkNotificationAsReadInput = {
  /** Server-assigned notification row id to mark as read. */
  notificationId: Scalars['ID']['input'];
};

/** Typed outcome of `markNotificationAsRead` — Success, or Failure when the id is unknown/not owned by the caller. */
export type MarkNotificationAsReadResult = MarkNotificationAsReadFailure | MarkNotificationAsReadSuccess;

/** Successful outcome of `markNotificationAsRead`. */
export type MarkNotificationAsReadSuccess = {
  __typename?: 'MarkNotificationAsReadSuccess';
  success: Scalars['Boolean']['output'];
};

/** The org-wide maximum amount a member may schedule for a single one-time payment. */
export type MaximumPaymentAmountType = {
  __typename?: 'MaximumPaymentAmountType';
  /** Maximum amount, in dollars. */
  amount: Scalars['Float']['output'];
  /** SF-admin-authored description of this configured maximum. */
  description: Scalars['String']['output'];
};

export type MeType = {
  __typename?: 'MeType';
  acceptingPatients?: Maybe<Scalars['Boolean']['output']>;
  connectUserId?: Maybe<Scalars['String']['output']>;
  contactId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  featureFlags?: Maybe<Scalars['JSON']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  labUserId?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  memberId?: Maybe<Scalars['String']['output']>;
  messagingMailboxId?: Maybe<Scalars['String']['output']>;
  mobilePhone?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  practiceId?: Maybe<Scalars['String']['output']>;
  practiceWebsite?: Maybe<Scalars['String']['output']>;
  profileName?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  providerImageUrl?: Maybe<Scalars['String']['output']>;
  sfUsername?: Maybe<Scalars['String']['output']>;
  userType: UserType;
};

export type Member = {
  __typename?: 'Member';
  /** Salesforce Account Id of the member's practice. */
  accountId?: Maybe<Scalars['String']['output']>;
  /** Membership MSRP amount. */
  amountMsrp?: Maybe<Scalars['Float']['output']>;
  /** Whether AutoPay is enabled. */
  autoPay?: Maybe<Scalars['Boolean']['output']>;
  /** Whether billing routes to a national account. */
  billToNationalAccount?: Maybe<Scalars['Boolean']['output']>;
  /** Number of days the balance is past due. */
  billingDaysPastDue?: Maybe<Scalars['Float']['output']>;
  /** Current agreement MSRP (annual fee). */
  currentAgreementMsrp?: Maybe<Scalars['Float']['output']>;
  /** Current agreement payment schedule. */
  currentAgreementPaymentSchedule?: Maybe<Scalars['String']['output']>;
  /** Current balance (formula field). */
  currentBalanceFormula?: Maybe<Scalars['Float']['output']>;
  /** Current membership type. */
  currentMembershipType?: Maybe<Scalars['String']['output']>;
  /** Date of birth (yyyy-MM-dd). */
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  /** Date of the oldest unpaid invoice (yyyy-MM-dd). */
  dateOfOldestUnpaidInvoice?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** Emergency contact phone number. */
  emergencyPhone?: Maybe<Scalars['String']['output']>;
  /** Employer name. */
  employer?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** Gender. */
  gender?: Maybe<Gender>;
  /** Salesforce Contact Id. */
  id: Scalars['ID']['output'];
  /** Job title. */
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mailingAddress?: Maybe<PostalAddress>;
  /** MDVIP member Id. */
  mdvipId?: Maybe<Scalars['String']['output']>;
  /** Date the member's current membership was established (yyyy-MM-dd). */
  memberSince?: Maybe<Scalars['String']['output']>;
  /** Membership status. */
  memberStatus?: Maybe<Scalars['String']['output']>;
  /** Mobile phone number. */
  mobilePhone?: Maybe<Scalars['String']['output']>;
  otherAddress?: Maybe<PostalAddress>;
  phone?: Maybe<Scalars['String']['output']>;
  /** Preferred method of communication. */
  preferredContactMethod?: Maybe<PreferredContactMethod>;
  /** Primary insurance company name. */
  primaryInsurance?: Maybe<Scalars['String']['output']>;
  /** SAS-signed URL for the member's profile photo, or null if a SAS could not be minted. When non-null, it always resolves to a URL whether or not a photo has been uploaded yet — a 404 on that URL is the no-photo signal. */
  profilePhotoUrl?: Maybe<ProfilePhotoUrl>;
  /** Salutation / title (e.g. Mr., Dr.). */
  salutation?: Maybe<Scalars['String']['output']>;
  /** Secondary insurance company name. */
  secondaryInsurance?: Maybe<Scalars['String']['output']>;
  /** Which servicing arrangement covers the member's membership. Resolved on the member's own read; null on reads that do not project it. */
  serviceState?: Maybe<MemberServiceState>;
  /** Work phone number. */
  workPhone?: Maybe<Scalars['String']['output']>;
};

export type MemberDirectoryEntry = {
  __typename?: 'MemberDirectoryEntry';
  /** Salesforce Account Id of the member's practice. */
  accountId?: Maybe<Scalars['String']['output']>;
  /** Computed age in years. */
  age?: Maybe<Scalars['Float']['output']>;
  /** Balance aged 1-30 days past due. */
  aging30?: Maybe<Scalars['Float']['output']>;
  /** Balance aged 31-60 days past due. */
  aging60?: Maybe<Scalars['Float']['output']>;
  /** Balance aged 61-90 days past due. */
  aging90?: Maybe<Scalars['Float']['output']>;
  /** Balance aged 91-120+ days past due. */
  aging120?: Maybe<Scalars['Float']['output']>;
  /** Current (not-yet-due) balance. */
  agingCurrent?: Maybe<Scalars['Float']['output']>;
  /** Membership MSRP amount. */
  amountMsrp?: Maybe<Scalars['Float']['output']>;
  /** Whether AutoPay is enabled. */
  autoPay?: Maybe<Scalars['Boolean']['output']>;
  /** Whether billing routes to a national account. */
  billToNationalAccount?: Maybe<Scalars['Boolean']['output']>;
  /** Number of days the balance is past due. */
  billingDaysPastDue?: Maybe<Scalars['Float']['output']>;
  /** Whether the member can be sent a secure message. Derived from a mailbox id that is never exposed raw; null on a read that did not select it. */
  canSendMessage?: Maybe<Scalars['Boolean']['output']>;
  /** Current agreement MSRP (annual fee). */
  currentAgreementMsrp?: Maybe<Scalars['Float']['output']>;
  /** Current agreement payment schedule. */
  currentAgreementPaymentSchedule?: Maybe<Scalars['String']['output']>;
  /** Current balance (formula field). */
  currentBalanceFormula?: Maybe<Scalars['Float']['output']>;
  /** Current membership type. */
  currentMembershipType?: Maybe<Scalars['String']['output']>;
  /** Date of birth (yyyy-MM-dd). */
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  /** Date of the oldest unpaid invoice (yyyy-MM-dd). */
  dateOfOldestUnpaidInvoice?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** Emergency contact phone number. */
  emergencyPhone?: Maybe<Scalars['String']['output']>;
  /** Employer name. */
  employer?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** Gender. */
  gender?: Maybe<Gender>;
  /** Salesforce Contact Id. */
  id: Scalars['ID']['output'];
  /** Insurance carrier name from the member's Insurance lookup — distinct from primaryInsurance, which is a separate free-text field. */
  insuranceName?: Maybe<Scalars['String']['output']>;
  isHealthChampion: Scalars['Boolean']['output'];
  /** Job title. */
  jobTitle?: Maybe<Scalars['String']['output']>;
  /** Date of the member's last wellness exam (yyyy-MM-dd). */
  lastAwpDate?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** Amount of the member's last payment. */
  lastPaymentAmount?: Maybe<Scalars['Float']['output']>;
  /** Date of the member's last payment (yyyy-MM-dd). */
  lastPaymentDate?: Maybe<Scalars['String']['output']>;
  mailingAddress?: Maybe<PostalAddress>;
  /** MDVIP member Id. */
  mdvipId?: Maybe<Scalars['String']['output']>;
  /** Date the member's current membership was established (yyyy-MM-dd). */
  memberSince?: Maybe<Scalars['String']['output']>;
  /** Membership status. */
  memberStatus?: Maybe<Scalars['String']['output']>;
  /** Mobile phone number. */
  mobilePhone?: Maybe<Scalars['String']['output']>;
  /** Name of the corporate account billed for this member, if any. */
  nationalAccountName?: Maybe<Scalars['String']['output']>;
  /** Computed next-birthday date (yyyy-MM-dd). */
  nextBirthday?: Maybe<Scalars['String']['output']>;
  otherAddress?: Maybe<PostalAddress>;
  phone?: Maybe<Scalars['String']['output']>;
  /** Preferred method of communication. */
  preferredContactMethod?: Maybe<PreferredContactMethod>;
  /** Primary insurance company name. */
  primaryInsurance?: Maybe<Scalars['String']['output']>;
  /** SAS-signed URL for the member's profile photo, or null if a SAS could not be minted. When non-null, it always resolves to a URL whether or not a photo has been uploaded yet — a 404 on that URL is the no-photo signal. */
  profilePhotoUrl?: Maybe<ProfilePhotoUrl>;
  /** Computed membership renewal date (yyyy-MM-dd). */
  renewalDate?: Maybe<Scalars['String']['output']>;
  /** Salutation / title (e.g. Mr., Dr.). */
  salutation?: Maybe<Scalars['String']['output']>;
  /** Secondary insurance company name. */
  secondaryInsurance?: Maybe<Scalars['String']['output']>;
  /** Which servicing arrangement covers the member's membership. Resolved on the member's own read; null on reads that do not project it. */
  serviceState?: Maybe<MemberServiceState>;
  /** Work phone number. */
  workPhone?: Maybe<Scalars['String']['output']>;
};

/** Which servicing arrangement covers the member's membership — MEMBER | SERVICE. Derived from the practice Account's `Member_Service_State__c`. Within a read that resolves it, Salesforce holding no value — or one outside this set — reads as SERVICE. */
export type MemberServiceState =
  | 'MEMBER'
  | 'SERVICE';

export type Mutation = {
  __typename?: 'Mutation';
  /** Persists a verified + tokenized bank account (ACH) to Salesforce and returns the saved account. */
  addBankAccount: AddBankAccountResult;
  /** Persists a verified + tokenized credit card to Salesforce and returns the saved card. */
  addCreditCard: AddCreditCardResult;
  /** Saves an entity reference to one of the authenticated member's lists. Idempotent — calling it again with the same arguments returns the existing bookmark, with its original `createdAt`. */
  addMyBookmark: Bookmark;
  /** Cancels a scheduled one-time payment belonging to the authenticated member. The cancelled payment stops appearing in `myUpcomingPayments`. */
  cancelUpcomingPayment: CancelUpcomingPaymentResult;
  /** Mints a short-lived, write-only SAS URL for the authenticated member's own profile photo blob. PUT the new photo directly to this URL — there is no separate confirmation mutation. */
  createProfilePhotoUploadUrl: ProfilePhotoUploadUrl;
  /** Dismisses one of the authenticated caller's notifications, if its type allows manual dismiss. */
  dismissNotification: DismissNotificationResult;
  /** Updates a saved bank account's metadata (bank name, account type, name on account, HSA flag, default, billing address). Routing / account digits and gateway tokens are immutable and cannot be edited. */
  editBankAccount: EditBankAccountResult;
  /** Updates a saved credit card's metadata (name, expiry, HSA flag, default, billing address, classifications). PAN and gateway tokens are immutable and cannot be edited. */
  editCreditCard: EditCreditCardResult;
  /** Enrolls the authenticated member in AutoPay, flipping their own Contact.AutoPay__c to true and Print_Invoice__c to false in Salesforce. */
  enableMyAutoPay: EnableMyAutoPayResult;
  /** Marks every one of the authenticated caller's pending, unread notifications as read. */
  markAllNotificationsAsRead: MarkAllNotificationsAsReadSuccess;
  /** Marks one of the authenticated caller's notifications as read. */
  markNotificationAsRead: MarkNotificationAsReadResult;
  /** Removes (soft-deletes via `Active__c = false`) a saved bank account (ACH) belonging to the authenticated member. Rejects removal of the current default — promote another payment method first. */
  removeBankAccount: RemoveBankAccountResult;
  /** Removes (soft-deletes via `Active__c = false`) a saved credit card belonging to the authenticated member. Rejects removal of the current default card — promote another card first. */
  removeCreditCard: RemoveCreditCardResult;
  /** Removes an entity reference from one of the authenticated member's lists. Idempotent — returns `true` even when no such bookmark existed. */
  removeMyBookmark: Scalars['Boolean']['output'];
  /** Schedules a one-time payment toward the authenticated member's balance. */
  scheduleOneTimePayment: ScheduleOneTimePaymentResult;
  /** Emails the authenticated member a receipt for one of their own past payments. */
  sendPaymentReceiptEmail: SendPaymentReceiptEmailResult;
  /** Sets any active, owned payment method (credit card or bank account) as the authenticated member's default. */
  setDefaultPaymentMethod: SetDefaultPaymentMethodResult;
  /** Files a support request under the given category. The server resolves the recipient and all email content from the category — the client supplies only its key and the member's own form fields. */
  submitContactUsRequest: SubmitContactUsRequestResult;
  /** Refers one or more people to the authenticated member's own physician. Each prospect receives a separate, personalized email; the referring member receives a confirmation only if every referral was sent. */
  submitReferral: SubmitReferralResult;
  /** Updates the authenticated member's own profile fields in Salesforce. Each optional field is three-state: omit it to leave the stored value unchanged, pass null to clear it, or pass a value to overwrite it. */
  updateMyMemberInfo: UpdateMyMemberInfoSuccess;
  /** Verifies bank-account (ACH) information with the payment gateway. */
  verifyBankAccountInformation: VerifyBankAccountInformationResult;
  /** Verifies credit card information with the payment gateway. */
  verifyCreditCardInformation: VerifyCreditCardInformationResult;
};


export type MutationAddBankAccountArgs = {
  input: AddBankAccountInput;
};


export type MutationAddCreditCardArgs = {
  input: AddCreditCardInput;
};


export type MutationAddMyBookmarkArgs = {
  input: AddMyBookmarkInput;
};


export type MutationCancelUpcomingPaymentArgs = {
  input: CancelUpcomingPaymentInput;
};


export type MutationDismissNotificationArgs = {
  input: DismissNotificationInput;
};


export type MutationEditBankAccountArgs = {
  id: Scalars['ID']['input'];
  input: EditBankAccountInput;
};


export type MutationEditCreditCardArgs = {
  id: Scalars['ID']['input'];
  input: EditCreditCardInput;
};


export type MutationMarkNotificationAsReadArgs = {
  input: MarkNotificationAsReadInput;
};


export type MutationRemoveBankAccountArgs = {
  input: RemoveBankAccountInput;
};


export type MutationRemoveCreditCardArgs = {
  input: RemoveCreditCardInput;
};


export type MutationRemoveMyBookmarkArgs = {
  input: RemoveMyBookmarkInput;
};


export type MutationScheduleOneTimePaymentArgs = {
  input: ScheduleOneTimePaymentInput;
};


export type MutationSendPaymentReceiptEmailArgs = {
  paymentId: Scalars['ID']['input'];
};


export type MutationSetDefaultPaymentMethodArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSubmitContactUsRequestArgs = {
  input: SubmitContactUsRequestInput;
};


export type MutationSubmitReferralArgs = {
  input: SubmitReferralInput;
};


export type MutationUpdateMyMemberInfoArgs = {
  input: UpdateMyMemberInfoInput;
};


export type MutationVerifyBankAccountInformationArgs = {
  input: VerifyBankAccountInput;
};


export type MutationVerifyCreditCardInformationArgs = {
  input: VerifyCreditCardInformationInput;
};

/** The caller's practice's complete Active+Suspended member roster. */
export type MyActiveMembersSuccess = {
  __typename?: 'MyActiveMembersSuccess';
  /** Every Active or Suspended member on the caller's practice, sorted by last name. */
  edges: Array<MemberDirectoryEntry>;
};

/** Which entity ids to check against the caller's bookmarks. */
export type MyBookmarkedEntityIdsInput = {
  /** Entity ids to check — 1 to 100 per call. Intended for one screenful. */
  entityIds: Array<Scalars['String']['input']>;
  /** Which entity type the ids belong to. */
  entityType: BookmarkEntityType;
  /** Restrict the check to one kind. Omit to match any kind. */
  kind?: InputMaybe<BookmarkKind>;
};

/** Pagination + filter options for `myBookmarks`. */
export type MyBookmarksInput = {
  /** Which entity type to list. */
  entityType: BookmarkEntityType;
  /** Restrict to one kind. Omit to return any kind. */
  kind?: InputMaybe<BookmarkKind>;
  /** Pagination — max records to return. Defaults to 25, hard ceiling 100. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Pagination — number of records to skip. Defaults to 0. */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A page of the authenticated member's bookmarks. */
export type MyBookmarksPage = {
  __typename?: 'MyBookmarksPage';
  /** Bookmarks in this page, most recently saved first. Pointers only — hydrate `entityId` separately, and tolerate misses: entity the member saved may since have been removed upstream. */
  edges: Array<Bookmark>;
  /** Post-filter count for this page: rows in `edges` after the API drops any whose stored entity type is unknown to this build (possible mid-rollout of a new type). Equal to `edges.length`. */
  filteredCount: Scalars['Int']['output'];
  /** Echoed `limit` from the request. */
  limit: Scalars['Int']['output'];
  /** Echoed `offset` from the request. */
  offset: Scalars['Int']['output'];
  /** Pre-filter count: the caller's total matching bookmarks across all pages, unbounded by `limit`/`offset`. Reliable pagination stop condition: `offset + limit >= totalCount` — do NOT use `edges.length < limit`. Counts bookmarks, not hydratable entity. */
  totalCount: Scalars['Int']['output'];
};

export type MyFeatureFlagsType = {
  __typename?: 'MyFeatureFlagsType';
  AWPAudit__c: Scalars['Boolean']['output'];
  AWPCreate__c: Scalars['Boolean']['output'];
  AWPManage__c: Scalars['Boolean']['output'];
  AWPPlus__c: Scalars['Boolean']['output'];
  AWPRead__c: Scalars['Boolean']['output'];
  AcceptingJuniorMembers__c: Scalars['Boolean']['output'];
  AnalyticsReport__c: Scalars['Boolean']['output'];
  ApparelandMerchandise__c: Scalars['Boolean']['output'];
  Cardiology__c: Scalars['Boolean']['output'];
  CollateralandStationary__c: Scalars['Boolean']['output'];
  Endocrinology__c: Scalars['Boolean']['output'];
  EventsandMarketingMaterials__c: Scalars['Boolean']['output'];
  FinancialReports__c: Scalars['Boolean']['output'];
  Foundation__c: Scalars['Boolean']['output'];
  MCEReferrals__c: Scalars['Boolean']['output'];
  MDVIPWebmail__c: Scalars['Boolean']['output'];
  ManageCHL__c: Scalars['Boolean']['output'];
  ManageGroupPractice__c: Scalars['Boolean']['output'];
  ManageOfficeHours__c: Scalars['Boolean']['output'];
  ManagePayments__c: Scalars['Boolean']['output'];
  ManagePortalUser__c: Scalars['Boolean']['output'];
  MedicalResources__c: Scalars['Boolean']['output'];
  MemberSatisfaction__c: Scalars['Boolean']['output'];
  MensHealth__c: Scalars['Boolean']['output'];
  MyEvents__c: Scalars['Boolean']['output'];
  MyInitiatives__c: Scalars['Boolean']['output'];
  MyWaitinglist__c: Scalars['Boolean']['output'];
  Notifications__c: Scalars['Boolean']['output'];
  OfficeDepotOfficeMax__c: Scalars['Boolean']['output'];
  Patients__c: Scalars['Boolean']['output'];
  Pediatric__c: Scalars['Boolean']['output'];
  Programs__c: Scalars['Boolean']['output'];
  Prospects__c: Scalars['Boolean']['output'];
  ReciprocityVisit__c: Scalars['Boolean']['output'];
  SecureMessaging__c: Scalars['Boolean']['output'];
  SecureMsg_Read_Only__c: Scalars['Boolean']['output'];
  Staplesdotcom__c: Scalars['Boolean']['output'];
  ToDos__c: Scalars['Boolean']['output'];
  ValueBasedCare__c: Scalars['Boolean']['output'];
  WomensHealth__c: Scalars['Boolean']['output'];
};

/** The caller's practice's Future Cancellations member roster. */
export type MyFutureCancellationMembersSuccess = {
  __typename?: 'MyFutureCancellationMembersSuccess';
  /** Every Active or Suspended member on the caller's practice with a pending cancellation on record, autopay off, and not on a Scholarship/Employee payment schedule, sorted by next renewal date (soonest first). */
  edges: Array<FutureCancellationMemberDirectoryEntry>;
};

/** The caller's practice's complete roster of Active/Suspended members approaching their 65th birthday. */
export type MyIppeCalculationMembersSuccess = {
  __typename?: 'MyIppeCalculationMembersSuccess';
  /** Every Active or Suspended member on the caller's practice who is currently 64 with a next birthday within 90 days, sorted by last name. */
  edges: Array<IppeCalculationMemberDirectoryEntry>;
};

/** The caller's practice's New Members: current members who enrolled or transferred in within the last year. */
export type MyNewMembersSuccess = {
  __typename?: 'MyNewMembersSuccess';
  /** Every current member on the caller's practice with a qualifying enrollment or transfer-in in the last year, sorted by last name then first name. Each carries effectiveDate. */
  edges: Array<NewMemberDirectoryEntry>;
};

/** The caller's practice's complete roster of Active/Suspended, non-Scholarship members with an outstanding Annual Wellness Program visit. */
export type MyOutstandingAwpMembersSuccess = {
  __typename?: 'MyOutstandingAwpMembersSuccess';
  /** Every Active or Suspended, non-Scholarship member on the caller's practice whose last AWP visit is more than 365 days old or was never recorded, most overdue first (never-recorded first of all). */
  edges: Array<MemberDirectoryEntry>;
};

/** The caller's practice's Past Due member roster. */
export type MyPastDueMembersSuccess = {
  __typename?: 'MyPastDueMembersSuccess';
  /** Every Active member on the caller's practice 1-60 days past due, excluding company-paid corporate members, sorted most overdue first. */
  edges: Array<PastDueMemberDirectoryEntry>;
};

export type MyPaymentPlanFailure = DomainError & {
  __typename?: 'MyPaymentPlanFailure';
  /** Machine-readable failure category. Stable across releases. */
  code: MyPaymentPlanFailureCode;
  /** User-facing message. Safe to display directly. */
  message: Scalars['String']['output'];
};

/** Machine-readable failure category for `myPaymentPlan`. Stable across releases — drives client dispatch. */
export type MyPaymentPlanFailureCode =
  | 'NO_ACTIVE_PAYMENT_PLAN';

/** Typed outcome of `myPaymentPlan` — Success with the caller's plan details, Failure when no active payment plan exists (`NO_ACTIVE_PAYMENT_PLAN`). Infrastructure and caller errors surface as GraphQL `errors`, not as result variants. */
export type MyPaymentPlanResult = MyPaymentPlanFailure | MyPaymentPlanSuccess;

/** Successful outcome of `myPaymentPlan`. Carries the caller's billing cadence and annual membership fee. */
export type MyPaymentPlanSuccess = {
  __typename?: 'MyPaymentPlanSuccess';
  /** Annual membership fee. */
  annualTotal: Scalars['Float']['output'];
  /** Billing cadence, e.g. "Quarterly". */
  cadence: Scalars['String']['output'];
};

/** Pagination + filter options for `myPaymentTransactions`. All fields optional — see Zod schema for defaults. */
export type MyPaymentTransactionsInput = {
  /** Pagination — max records to return. Defaults to 25, hard ceiling 100. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Pagination — number of records to skip. Defaults to 0. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Transaction types to include. Defaults to [PAYMENT] only — matches legacy's default filter, excluding Refund/Payment Reversal/Credit Memo unless explicitly widened. */
  types?: InputMaybe<Array<TransactionType>>;
};

/** A page of the authenticated member's payment transactions. */
export type MyPaymentTransactionsSuccess = {
  __typename?: 'MyPaymentTransactionsSuccess';
  /** Transactions in this page, sorted by date descending (most recent first). */
  edges: Array<PaymentTransaction>;
  /** Post-filter count for this page: number of transactions in `edges` after per-row parse failures are dropped. Equal to `edges.length`. */
  filteredCount: Scalars['Int']['output'];
  /** Echoed `limit` from the request. */
  limit: Scalars['Int']['output'];
  /** Echoed `offset` from the request. */
  offset: Scalars['Int']['output'];
  /** Pre-filter count: total transactions matching the SOQL `WHERE` clause across all pages (sourced from a parallel SOQL `SELECT COUNT()` query — see service). */
  totalCount: Scalars['Int']['output'];
};

export type MyPermissionsType = {
  __typename?: 'MyPermissionsType';
  rules: Scalars['JSON']['output'];
};

/** Filter + pagination options for `myPracticeMembers`. All fields optional — see Zod schema for defaults. */
export type MyPracticeMembersInput = {
  /** Pagination — max records to return. Defaults to 2000 (Salesforce's own per-query ceiling) — omit to get the whole roster in one page. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Pagination — number of records to skip. Defaults to 0. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Exact Member_Status__c picklist values to filter to (Active, Suspended, Inactive, Survey, Prospecting, Not Interested). Omit or send [] for unfiltered. */
  status?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A page of the caller's practice member roster. */
export type MyPracticeMembersSuccess = {
  __typename?: 'MyPracticeMembersSuccess';
  /** Members in this page, sorted by first name ascending. */
  edges: Array<Member>;
  /** Echoed `limit` from the request. */
  limit: Scalars['Int']['output'];
  /** Echoed `offset` from the request. */
  offset: Scalars['Int']['output'];
  /** Total members matching the caller's practice (and status filter, if given) across all pages — sourced from a parallel SOQL `SELECT COUNT()` query. */
  totalCount: Scalars['Int']['output'];
};

/** The caller's practice's complete roster of Active members renewing within 90 days who are recommended for outreach. */
export type MyRecommendedOutreachMembersSuccess = {
  __typename?: 'MyRecommendedOutreachMembersSuccess';
  /** Every Active member on the caller's practice whose renewal is within the next 90 days, with a cancellation probability above 50, no pending cancellation, no corporate billing parent, no days past due, and a payment schedule other than Scholarship/Employee — ordered by last name. */
  edges: Array<MemberDirectoryEntry>;
};

export type MySavedPaymentMethodsFailure = DomainError & {
  __typename?: 'MySavedPaymentMethodsFailure';
  /** Machine-readable failure category. Stable across releases. */
  code: MySavedPaymentMethodsFailureCode;
  /** User-facing message. Safe to display directly. */
  message: Scalars['String']['output'];
};

/** Machine-readable failure category for `mySavedPaymentMethods`. Stable across releases — drives client dispatch. */
export type MySavedPaymentMethodsFailureCode =
  | 'INVALID_INPUT';

/** Pagination + filter options for `mySavedPaymentMethods`. All fields optional — see Zod schema for defaults. */
export type MySavedPaymentMethodsInput = {
  /** When true, include expired payment methods (today: credit cards only). Defaults to true — the UI groups them under 'Expired'. */
  includeExpired?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, include inactive (deactivated) payment methods. Defaults to false. */
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Pagination — max records to return. Defaults to 25, hard ceiling 100. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Pagination — number of records to skip. Defaults to 0. */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Typed outcome of `mySavedPaymentMethods` — Success on a returned page, Failure on a domain-level rejection. Infrastructure errors surface as GraphQL `errors`, not as result variants. */
export type MySavedPaymentMethodsResult = MySavedPaymentMethodsFailure | MySavedPaymentMethodsSuccess;

/** Successful page of the authenticated member's saved payment methods. */
export type MySavedPaymentMethodsSuccess = {
  __typename?: 'MySavedPaymentMethodsSuccess';
  /** Payment methods in this page. Each element is one of the `SavedPaymentMethod` variants — `SavedCreditCard` or `SavedBankAccount` (ACH) today; digital-wallet variants are planned. */
  edges: Array<SavedPaymentMethod>;
  /** Post-filter count for this page: number of cards in `edges` after the API drops expired cards when `includeExpired=false` (or per-row parse failures). Equal to `edges.length`. When `includeExpired=true` (default) and no rows are parse-dropped, `filteredCount` equals the SOQL row count for this page. Reliable pagination stop condition: `offset + limit >= totalCount` — do NOT use `edges.length < limit`, which can trigger early when includeExpired=false drops rows mid-stream. */
  filteredCount: Scalars['Int']['output'];
  /** Echoed `limit` from the request. */
  limit: Scalars['Int']['output'];
  /** Echoed `offset` from the request. */
  offset: Scalars['Int']['output'];
  /** Pre-filter count: total payment-method profiles matching the SOQL `WHERE` clause across all pages (sourced from a parallel SOQL `SELECT COUNT()` query — see service). When `includeExpired=false`, this is the pre-expiry-drop total — use `filteredCount` (this page) for the actual cards returned, not `totalCount / limit` rounded up. */
  totalCount: Scalars['Int']['output'];
};

/** The caller's practice's complete roster of Active/Suspended members on a Scholarship billing schedule. */
export type MyScholarshipMembersSuccess = {
  __typename?: 'MyScholarshipMembersSuccess';
  /** Every Active or Suspended member on the caller's practice whose billing schedule is Scholarship, sorted by last name ascending. */
  edges: Array<ScholarshipMemberDirectoryEntry>;
};

/** The caller's practice's complete Suspended member roster. */
export type MySuspendedMembersSuccess = {
  __typename?: 'MySuspendedMembersSuccess';
  /** Every Suspended member on the caller's practice, sorted by last name. */
  edges: Array<MemberDirectoryEntry>;
};

/** The caller's practice's complete roster of Active members with an upcoming renewal. */
export type MyUpcomingRenewalMembersSuccess = {
  __typename?: 'MyUpcomingRenewalMembersSuccess';
  /** Every Active member on the caller's practice with a renewal coming up soon, sorted by renewal date descending. */
  edges: Array<MemberDirectoryEntry>;
};

export type NewMemberDirectoryEntry = {
  __typename?: 'NewMemberDirectoryEntry';
  /** Salesforce Account Id of the member's practice. */
  accountId?: Maybe<Scalars['String']['output']>;
  /** Computed age in years. */
  age?: Maybe<Scalars['Float']['output']>;
  /** Balance aged 1-30 days past due. */
  aging30?: Maybe<Scalars['Float']['output']>;
  /** Balance aged 31-60 days past due. */
  aging60?: Maybe<Scalars['Float']['output']>;
  /** Balance aged 61-90 days past due. */
  aging90?: Maybe<Scalars['Float']['output']>;
  /** Balance aged 91-120+ days past due. */
  aging120?: Maybe<Scalars['Float']['output']>;
  /** Current (not-yet-due) balance. */
  agingCurrent?: Maybe<Scalars['Float']['output']>;
  /** Membership MSRP amount. */
  amountMsrp?: Maybe<Scalars['Float']['output']>;
  /** Whether AutoPay is enabled. */
  autoPay?: Maybe<Scalars['Boolean']['output']>;
  /** Whether billing routes to a national account. */
  billToNationalAccount?: Maybe<Scalars['Boolean']['output']>;
  /** Number of days the balance is past due. */
  billingDaysPastDue?: Maybe<Scalars['Float']['output']>;
  /** Whether the member can be sent a secure message. Derived from a mailbox id that is never exposed raw; null on a read that did not select it. */
  canSendMessage?: Maybe<Scalars['Boolean']['output']>;
  /** Current agreement MSRP (annual fee). */
  currentAgreementMsrp?: Maybe<Scalars['Float']['output']>;
  /** Current agreement payment schedule. */
  currentAgreementPaymentSchedule?: Maybe<Scalars['String']['output']>;
  /** Current balance (formula field). */
  currentBalanceFormula?: Maybe<Scalars['Float']['output']>;
  /** Current membership type. */
  currentMembershipType?: Maybe<Scalars['String']['output']>;
  /** Date of birth (yyyy-MM-dd). */
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  /** Date of the oldest unpaid invoice (yyyy-MM-dd). */
  dateOfOldestUnpaidInvoice?: Maybe<Scalars['String']['output']>;
  /** Date (yyyy-MM-dd) of the member's most recent qualifying enrollment or transfer-in. */
  effectiveDate?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** Emergency contact phone number. */
  emergencyPhone?: Maybe<Scalars['String']['output']>;
  /** Employer name. */
  employer?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** Gender. */
  gender?: Maybe<Gender>;
  /** Salesforce Contact Id. */
  id: Scalars['ID']['output'];
  /** Insurance carrier name from the member's Insurance lookup — distinct from primaryInsurance, which is a separate free-text field. */
  insuranceName?: Maybe<Scalars['String']['output']>;
  isHealthChampion: Scalars['Boolean']['output'];
  /** Job title. */
  jobTitle?: Maybe<Scalars['String']['output']>;
  /** Date of the member's last wellness exam (yyyy-MM-dd). */
  lastAwpDate?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** Amount of the member's last payment. */
  lastPaymentAmount?: Maybe<Scalars['Float']['output']>;
  /** Date of the member's last payment (yyyy-MM-dd). */
  lastPaymentDate?: Maybe<Scalars['String']['output']>;
  /** How the member heard about the practice (Contact lead source). */
  leadSource?: Maybe<Scalars['String']['output']>;
  mailingAddress?: Maybe<PostalAddress>;
  /** MDVIP member Id. */
  mdvipId?: Maybe<Scalars['String']['output']>;
  /** Date the member's current membership was established (yyyy-MM-dd). */
  memberSince?: Maybe<Scalars['String']['output']>;
  /** Membership status. */
  memberStatus?: Maybe<Scalars['String']['output']>;
  /** Mobile phone number. */
  mobilePhone?: Maybe<Scalars['String']['output']>;
  /** Name of the corporate account billed for this member, if any. */
  nationalAccountName?: Maybe<Scalars['String']['output']>;
  /** Computed next-birthday date (yyyy-MM-dd). */
  nextBirthday?: Maybe<Scalars['String']['output']>;
  otherAddress?: Maybe<PostalAddress>;
  phone?: Maybe<Scalars['String']['output']>;
  /** Preferred method of communication. */
  preferredContactMethod?: Maybe<PreferredContactMethod>;
  /** Primary insurance company name. */
  primaryInsurance?: Maybe<Scalars['String']['output']>;
  /** SAS-signed URL for the member's profile photo, or null if a SAS could not be minted. When non-null, it always resolves to a URL whether or not a photo has been uploaded yet — a 404 on that URL is the no-photo signal. */
  profilePhotoUrl?: Maybe<ProfilePhotoUrl>;
  /** Computed membership renewal date (yyyy-MM-dd). */
  renewalDate?: Maybe<Scalars['String']['output']>;
  /** Salutation / title (e.g. Mr., Dr.). */
  salutation?: Maybe<Scalars['String']['output']>;
  /** Secondary insurance company name. */
  secondaryInsurance?: Maybe<Scalars['String']['output']>;
  /** Which servicing arrangement covers the member's membership. Resolved on the member's own read; null on reads that do not project it. */
  serviceState?: Maybe<MemberServiceState>;
  /** Work phone number. */
  workPhone?: Maybe<Scalars['String']['output']>;
};

/** The authenticated member's next scheduled payment. Sourced from Jitterbit — no Salesforce object behind it. */
export type NextPaymentDueType = {
  __typename?: 'NextPaymentDueType';
  /** Amount of the next scheduled payment. `0` when none is currently scheduled; `null` only when Jitterbit omits the amount or it is unparseable. */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Due date of the next scheduled payment, ISO `yyyy-MM-dd`. Null when none is currently scheduled. */
  dueDate?: Maybe<Scalars['String']['output']>;
};

/** A single notification in the authenticated caller's notification list. Persisted and reconciled server-side — see notification.service.ts. */
export type Notification = {
  __typename?: 'Notification';
  /** Structured per-type payload (e.g. amount, expiration date). */
  detail?: Maybe<NotificationDetail>;
  /** Whether the caller may manually dismiss this notification. Declared per NotificationType by the owning producer — a condition-driven notification (e.g. a card expiring) is false, and can only disappear via automatic invalidation. */
  dismissible: Scalars['Boolean']['output'];
  /** Server-assigned notification row id. */
  id: Scalars['ID']['output'];
  /** Whether the caller has marked this notification read. */
  isRead: Scalars['Boolean']['output'];
  /** When the underlying fact occurred, per the producer (e.g. an invoice's due date, a card's real expiration date). Producer-specific display content — NOT the list's sort order (see notification.service.ts, which orders by createdAt instead). */
  occurredAt: Scalars['Date']['output'];
  /** When the caller marked this read, if ever. */
  readAt?: Maybe<Scalars['Date']['output']>;
  /** Literal destination URL the frontend navigates to when the notification is clicked. Null when the notification has no click-through action. */
  targetUrl?: Maybe<Scalars['String']['output']>;
  /** Notification category / producer identity. */
  type: NotificationType;
};

/** Structured per-type payload for a notification. `message` is a server-composed, ready-to-display sentence — render it directly, do not re-derive or reformat it. The remaining fields are per-producer and nullable. */
export type NotificationDetail = {
  __typename?: 'NotificationDetail';
  /** Outstanding balance amount. BALANCE_PAST_DUE only. */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Number of days the balance is past due (due-today-inclusive). BALANCE_PAST_DUE only. */
  daysPastDue?: Maybe<Scalars['Int']['output']>;
  /** Expiration month, 1-12. PAYMENT_METHOD_EXPIRING only. */
  expirationMonth?: Maybe<Scalars['Int']['output']>;
  /** Expiration year, 4-digit. PAYMENT_METHOD_EXPIRING only. */
  expirationYear?: Maybe<Scalars['Int']['output']>;
  /** True if the card has already expired, false if it's expiring within 30 days. PAYMENT_METHOD_EXPIRING only. */
  isExpired?: Maybe<Scalars['Boolean']['output']>;
  /** Last 4 digits of the card. PAYMENT_METHOD_EXPIRING only. */
  last4?: Maybe<Scalars['String']['output']>;
  /** Server-composed, ready-to-display sentence (e.g. "Your balance is 15 days past due. Tap to make a payment."). Render directly — never re-derive or reformat client-side. */
  message?: Maybe<Scalars['String']['output']>;
  /** Card network — AMEX | VISA | MC | DISC. PAYMENT_METHOD_EXPIRING only. */
  network?: Maybe<CardNetwork>;
};

/** Notification category / producer identity. */
export type NotificationType =
  | 'BALANCE_PAST_DUE'
  | 'PAYMENT_METHOD_EXPIRING';

/** One nutrition fact, parsed from the vendor's display string. */
export type NutritionFact = {
  __typename?: 'NutritionFact';
  /** e.g. 'Total Fat', 'Vitamin B3'. */
  label: Scalars['String']['output'];
  /** e.g. '16 g', '4 mg' — vendor's own formatting, unit included. */
  value: Scalars['String']['output'];
};

export type PastDueMemberDirectoryEntry = {
  __typename?: 'PastDueMemberDirectoryEntry';
  /** Salesforce Account Id of the member's practice. */
  accountId?: Maybe<Scalars['String']['output']>;
  /** Computed age in years. */
  age?: Maybe<Scalars['Float']['output']>;
  /** Balance aged 1-30 days past due. */
  aging30?: Maybe<Scalars['Float']['output']>;
  /** Balance aged 31-60 days past due. */
  aging60?: Maybe<Scalars['Float']['output']>;
  /** Balance aged 61-90 days past due. */
  aging90?: Maybe<Scalars['Float']['output']>;
  /** Balance aged 91-120+ days past due. */
  aging120?: Maybe<Scalars['Float']['output']>;
  /** Current (not-yet-due) balance. */
  agingCurrent?: Maybe<Scalars['Float']['output']>;
  /** Membership MSRP amount. */
  amountMsrp?: Maybe<Scalars['Float']['output']>;
  /** Whether AutoPay is enabled. */
  autoPay?: Maybe<Scalars['Boolean']['output']>;
  /** Whether billing routes to a national account. */
  billToNationalAccount?: Maybe<Scalars['Boolean']['output']>;
  /** Number of days the balance is past due. */
  billingDaysPastDue?: Maybe<Scalars['Float']['output']>;
  /** Whether the member can be sent a secure message. Derived from a mailbox id that is never exposed raw; null on a read that did not select it. */
  canSendMessage?: Maybe<Scalars['Boolean']['output']>;
  /** Date of the member's last credit-card-decline call. */
  ccDeclineCall?: Maybe<Scalars['String']['output']>;
  /** Date of the member's last credit-card-decline letter. */
  ccDeclineLetter?: Maybe<Scalars['String']['output']>;
  /** Current agreement MSRP (annual fee). */
  currentAgreementMsrp?: Maybe<Scalars['Float']['output']>;
  /** Current agreement payment schedule. */
  currentAgreementPaymentSchedule?: Maybe<Scalars['String']['output']>;
  /** Current balance (formula field). */
  currentBalanceFormula?: Maybe<Scalars['Float']['output']>;
  /** Current membership type. */
  currentMembershipType?: Maybe<Scalars['String']['output']>;
  /** Date of birth (yyyy-MM-dd). */
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  /** Date of the oldest unpaid invoice (yyyy-MM-dd). */
  dateOfOldestUnpaidInvoice?: Maybe<Scalars['String']['output']>;
  /** Date of dunning call 1. */
  dunCall1?: Maybe<Scalars['String']['output']>;
  /** Date of dunning call 2. */
  dunCall2?: Maybe<Scalars['String']['output']>;
  /** Date of dunning call 3. */
  dunCall3?: Maybe<Scalars['String']['output']>;
  /** Date of dunning call 4. */
  dunCall4?: Maybe<Scalars['String']['output']>;
  /** Date of dunning email 1. */
  dunEmail1?: Maybe<Scalars['String']['output']>;
  /** Date of dunning email 2. */
  dunEmail2?: Maybe<Scalars['String']['output']>;
  /** Date of dunning email 3. */
  dunEmail3?: Maybe<Scalars['String']['output']>;
  /** Date of dunning email 4. */
  dunEmail4?: Maybe<Scalars['String']['output']>;
  /** Date of dunning letter 1. */
  dunLetter1?: Maybe<Scalars['String']['output']>;
  /** Date of dunning letter 2. */
  dunLetter2?: Maybe<Scalars['String']['output']>;
  /** Date of dunning letter 3. */
  dunLetter3?: Maybe<Scalars['String']['output']>;
  /** Date of dunning letter 4. */
  dunLetter4?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** Emergency contact phone number. */
  emergencyPhone?: Maybe<Scalars['String']['output']>;
  /** Employer name. */
  employer?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** Gender. */
  gender?: Maybe<Gender>;
  /** Salesforce Contact Id. */
  id: Scalars['ID']['output'];
  /** Insurance carrier name from the member's Insurance lookup — distinct from primaryInsurance, which is a separate free-text field. */
  insuranceName?: Maybe<Scalars['String']['output']>;
  isHealthChampion: Scalars['Boolean']['output'];
  /** Job title. */
  jobTitle?: Maybe<Scalars['String']['output']>;
  /** Date of the member's last wellness exam (yyyy-MM-dd). */
  lastAwpDate?: Maybe<Scalars['String']['output']>;
  /** Reason recorded for the member's last cancellation. */
  lastCancelReason?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** Amount of the member's last payment. */
  lastPaymentAmount?: Maybe<Scalars['Float']['output']>;
  /** Date of the member's last payment (yyyy-MM-dd). */
  lastPaymentDate?: Maybe<Scalars['String']['output']>;
  mailingAddress?: Maybe<PostalAddress>;
  /** MDVIP member Id. */
  mdvipId?: Maybe<Scalars['String']['output']>;
  /** Date the member's current membership was established (yyyy-MM-dd). */
  memberSince?: Maybe<Scalars['String']['output']>;
  /** Membership status. */
  memberStatus?: Maybe<Scalars['String']['output']>;
  /** Mobile phone number. */
  mobilePhone?: Maybe<Scalars['String']['output']>;
  /** Name of the corporate account billed for this member, if any. */
  nationalAccountName?: Maybe<Scalars['String']['output']>;
  /** Computed next-birthday date (yyyy-MM-dd). */
  nextBirthday?: Maybe<Scalars['String']['output']>;
  otherAddress?: Maybe<PostalAddress>;
  phone?: Maybe<Scalars['String']['output']>;
  /** Preferred method of communication. */
  preferredContactMethod?: Maybe<PreferredContactMethod>;
  /** Primary insurance company name. */
  primaryInsurance?: Maybe<Scalars['String']['output']>;
  /** SAS-signed URL for the member's profile photo, or null if a SAS could not be minted. When non-null, it always resolves to a URL whether or not a photo has been uploaded yet — a 404 on that URL is the no-photo signal. */
  profilePhotoUrl?: Maybe<ProfilePhotoUrl>;
  /** Computed membership renewal date (yyyy-MM-dd). */
  renewalDate?: Maybe<Scalars['String']['output']>;
  /** Salutation / title (e.g. Mr., Dr.). */
  salutation?: Maybe<Scalars['String']['output']>;
  /** Secondary insurance company name. */
  secondaryInsurance?: Maybe<Scalars['String']['output']>;
  /** Which servicing arrangement covers the member's membership. Resolved on the member's own read; null on reads that do not project it. */
  serviceState?: Maybe<MemberServiceState>;
  /** Work phone number. */
  workPhone?: Maybe<Scalars['String']['output']>;
};

/** Kind of payment method behind a transaction's account. UNKNOWN means a payment profile is linked but carries neither a recognizable card brand nor bank info — a data-integrity gap, not a normal state. */
export type PaymentAccountKind =
  | 'BANK'
  | 'CARD'
  | 'CHECK'
  | 'REMOVED'
  | 'UNKNOWN';

/** A single payment transaction on the authenticated member's history. Sourced from Salesforce `Transactions__c`. */
export type PaymentTransaction = {
  __typename?: 'PaymentTransaction';
  /** Classification of the payment method behind this transaction. */
  accountKind: PaymentAccountKind;
  /** Trailing digits identifying the account — `CCLast4__c` for `CARD`, `ACHLast6__c` for `BANK`. Length varies by kind; null for `CHECK`/`REMOVED`/`UNKNOWN`. */
  accountSuffix?: Maybe<Scalars['String']['output']>;
  /** Transaction amount (e.g. 1234.56). */
  amount: Scalars['Float']['output'];
  /** Bank name for the linked account, sourced from `ACHBankName__c`. Present only when `accountKind` is `BANK`. */
  bankName?: Maybe<Scalars['String']['output']>;
  /** Transaction date, ISO `yyyy-MM-dd` (Salesforce `Apply_Date__c`). */
  date: Scalars['String']['output'];
  /** Expiration month, 1–12. Present only when `accountKind` is `CARD`. */
  expirationMonth?: Maybe<Scalars['Int']['output']>;
  /** Expiration year. Present only when `accountKind` is `CARD`. */
  expirationYear?: Maybe<Scalars['Int']['output']>;
  /** Salesforce `Transactions__c` record ID. */
  id: Scalars['ID']['output'];
  /** Card network, present only when `accountKind` is `CARD`. Null when the brand value on the linked profile isn't a recognized network — the row is still returned, never dropped. */
  network?: Maybe<CardNetwork>;
  /** Transaction type. */
  type: TransactionType;
};

/** A postal address. Null when the member has no address on file; individual fields are null when blank. */
export type PostalAddress = {
  __typename?: 'PostalAddress';
  /** City. */
  city?: Maybe<Scalars['String']['output']>;
  /** Country. */
  country?: Maybe<Scalars['String']['output']>;
  /** Street address, first line. */
  line1?: Maybe<Scalars['String']['output']>;
  /** Street address, second line (suite, apt, etc.). */
  line2?: Maybe<Scalars['String']['output']>;
  /** State / region. */
  state?: Maybe<Scalars['String']['output']>;
  /** Postal / ZIP code. */
  zip?: Maybe<Scalars['String']['output']>;
};

export type Practice = {
  __typename?: 'Practice';
  /** Free-text card line. */
  additionalLine1?: Maybe<Scalars['String']['output']>;
  /** Free-text card line. */
  additionalLine2?: Maybe<Scalars['String']['output']>;
  /** Office address. Null when no address is on file. */
  address?: Maybe<PracticeAddress>;
  /** Up to 6 phone/label pairs for the membership card. A pair appears only when both its phone and label are on file; empty when none are. */
  cardContacts: Array<PracticeCardContactType>;
  /** Card-formatted display name. Distinct from `name` — the office-info card and the membership card read different Salesforce fields. */
  cardDisplayName?: Maybe<Scalars['String']['output']>;
  /** Co-brand partner name. Matching it to a logo is entirely frontend-side. */
  coBrandName?: Maybe<Scalars['String']['output']>;
  /** After-hours emergency phone number. */
  emergencyPhone?: Maybe<Scalars['String']['output']>;
  /** Salesforce Account Id of the practice. */
  id: Scalars['ID']['output'];
  /** Physician headshot URL. Not an office photo — no Salesforce field backs one yet. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Membership tier. Null when no tier is on file. */
  membershipTier?: Maybe<PracticeMembershipTier>;
  /** Practice name. */
  name?: Maybe<Scalars['String']['output']>;
  /** Weekly office hours. Null when no opening time is on file for any day. */
  officeHours?: Maybe<PracticeOfficeHours>;
  /** Main office phone number. */
  officePhone?: Maybe<Scalars['String']['output']>;
  /** The physician this office belongs to, by name. Null when no part of the name is on file. */
  physician?: Maybe<PracticePhysician>;
};

/** A practice's office address. Null when Salesforce holds no part of the address; individual fields are null when blank. Neither street line contains a line break, so both are safe to interpolate into a map or directions URL. */
export type PracticeAddress = {
  __typename?: 'PracticeAddress';
  /** City. */
  city?: Maybe<Scalars['String']['output']>;
  /** Street address, first line. */
  line1?: Maybe<Scalars['String']['output']>;
  /** Street address, second line (suite, apt, etc.). */
  line2?: Maybe<Scalars['String']['output']>;
  /** Postal / ZIP code. */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** State / region. */
  state?: Maybe<Scalars['String']['output']>;
};

/** One phone number on the membership card, with its picklist-controlled label. Both fields are always present — a pair with either side missing on Salesforce is excluded from cardContacts rather than surfaced with a null side. */
export type PracticeCardContactType = {
  __typename?: 'PracticeCardContactType';
  /** Label for this number, e.g. 'Main Office'. */
  label: Scalars['String']['output'];
  /** Phone number. */
  phone: Scalars['String']['output'];
};

/** One day's opening times, formatted as Salesforce serializes a Time field: HH:mm:ss.SSSZ (for example 10:00:00.000Z). The trailing Z is a serialization artifact, not a UTC offset — the value is a wall-clock time at the practice, so converting it to the viewer's timezone shifts it wrongly. Both fields are null on a day the office is closed. */
export type PracticeDayHours = {
  __typename?: 'PracticeDayHours';
  /** Closing time, e.g. 17:00:00.000Z. */
  end?: Maybe<Scalars['String']['output']>;
  /** Opening time, e.g. 09:00:00.000Z. */
  start?: Maybe<Scalars['String']['output']>;
};

/** Account.Membership_Tier__c, mapped to a known set of values. UNEXPECTED_TIER covers any live picklist value outside that set, so an unrecognized tier fails open with a value rather than failing the whole query. */
export type PracticeMembershipTier =
  | 'AWP_PLUS'
  | 'CARDIOLOGY'
  | 'ENDOCRINOLOGY'
  | 'MENS_HEALTH'
  | 'PEDIATRIC'
  | 'STANDARD_MEMBERSHIP'
  | 'UNEXPECTED_TIER'
  | 'WOMENS_HEALTH';

/** A practice's opening times for the week. Every day is present; a closed day carries null start and end. */
export type PracticeOfficeHours = {
  __typename?: 'PracticeOfficeHours';
  /** Friday's opening times. */
  friday: PracticeDayHours;
  /** Monday's opening times. */
  monday: PracticeDayHours;
  /** Saturday's opening times. */
  saturday: PracticeDayHours;
  /** Sunday's opening times. */
  sunday: PracticeDayHours;
  /** Thursday's opening times. */
  thursday: PracticeDayHours;
  /** Tuesday's opening times. */
  tuesday: PracticeDayHours;
  /** Wednesday's opening times. */
  wednesday: PracticeDayHours;
};

/** The physician this practice is named for, with their name split into parts. Null when Salesforce holds no part of the name; individual fields are null when blank. Practice.name is the same person's full label as the practice maintains it ('David Rizzo, DO') — read these parts to greet the physician by first name or sort by surname instead of splitting that label. */
export type PracticePhysician = {
  __typename?: 'PracticePhysician';
  /** Post-nominal medical credentials, e.g. 'DO', 'MD, FACP'. Practice.name already ends with these, so appending them to that label repeats them. */
  credentials?: Maybe<Scalars['String']['output']>;
  /** Given name, e.g. 'David'. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Family name, e.g. 'Rizzo'. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Middle name, e.g. 'Michael'. */
  middleName?: Maybe<Scalars['String']['output']>;
};

/** Member's preferred method of contact — EMAIL | MOBILE | MAIL | PHONE | WORK_PHONE. Maps to and from the Salesforce `Best_Method_Of_Communication__c` picklist display text (e.g. WORK_PHONE is stored as `Work Phone`); reads as null when Salesforce holds no value or one outside this set. */
export type PreferredContactMethod =
  | 'EMAIL'
  | 'MAIL'
  | 'MOBILE'
  | 'PHONE'
  | 'WORK_PHONE';

export type ProfilePhotoUploadUrl = {
  __typename?: 'ProfilePhotoUploadUrl';
  /** When the SAS in `url` stops working. */
  expiresAt: Scalars['Date']['output'];
  /** Write-only, single-blob SAS URL for uploading the member's profile photo. */
  url: Scalars['String']['output'];
};

export type ProfilePhotoUrl = {
  __typename?: 'ProfilePhotoUrl';
  /** When the SAS in `url` stops working. */
  expiresAt: Scalars['Date']['output'];
  /** Read-only, single-blob SAS URL for the member's profile photo. */
  url: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** Live term counts for the Topic and Article Type filters. Each vocabulary's counts ignore its own active selection but respect every other filter and the search. */
  articleFacets: Array<ArticleFacetGroup>;
  /** Browses the nutrition article catalog, with optional taxonomy filters, free-text search, and a bookmarked-only filter. */
  articles: ArticlesSuccess;
  clevelandHeartlabSessionUrl?: Maybe<Scalars['String']['output']>;
  /** Active Contact Us categories in display order. Returns labels and on-screen copy only — never recipient addresses or template content. */
  contactUsCategories: Array<ContactUsCategoryType>;
  /** Fetches the receipt PDF for one of the authenticated member's own past payments, for download. */
  downloadPaymentReceipt: DownloadPaymentReceiptResult;
  /** Fetches one nutrition article by its vendor item id. */
  getArticleByVendorId: Article;
  /** Fetches one recipe by its vendor item id. */
  getRecipeByVendorId: Recipe;
  /** Returns the org-wide maximum amount for a single one-time payment. */
  maximumPaymentAmount: MaximumPaymentAmountType;
  /** Returns the enriched session profile for the authenticated user */
  me: MeType;
  /** Returns a member by Salesforce Contact Id. Provider/staff only, scoped to their own practice — members must use myMemberInfo. */
  memberInfoByContactId?: Maybe<Member>;
  /** Returns the caller's practice's complete Active+Suspended member roster. Provider, or staff with member_management. No pagination arguments — the full dataset returns in one response. */
  myActiveMembers: MyActiveMembersSuccess;
  /** Returns the authenticated member's last AWP exam date and calculated next-due date. */
  myAwpStatus: AwpStatus;
  /** Returns the authenticated member's AWP visits (non-cancelled wellness exams), newest first, one per exam date; `mostRecent` limits it to the most recent N. Empty when no exam is on record. */
  myAwpVisits: Array<AwpVisit>;
  /** Given up to 100 entity ids, returns the subset the authenticated member has bookmarked. One query — use this to set save-icon state across a grid rather than calling per item. */
  myBookmarkedEntityIds: Array<Scalars['String']['output']>;
  /** Returns a page of the authenticated member's saved entity references. */
  myBookmarks: MyBookmarksPage;
  /** Returns the authenticated user's own feature flags. */
  myFeatureFlags: MyFeatureFlagsType;
  /** Returns the authenticated member's own PTLinked fitness widget boot config. */
  myFitnessWidgetConfig: FitnessWidgetConfigType;
  /** Returns the caller's practice's Active or Suspended members with a pending cancellation, autopay off, and not on a Scholarship/Employee payment schedule, soonest renewal first. Provider, or staff with member_management. No arguments — the full dataset returns in one response. */
  myFutureCancellationMembers: MyFutureCancellationMembersSuccess;
  /** Returns the caller's practice's complete roster of Active/Suspended members who are 64 with a next birthday within 90 days, with each member's suggested IPPE scheduling window. Provider, or staff with member_management. No arguments — the full dataset returns in one response. */
  myIppeCalculationMembers: MyIppeCalculationMembersSuccess;
  /** Returns the authenticated member's own record. */
  myMemberInfo?: Maybe<Member>;
  /** Returns the caller's practice's New Members: current members who enrolled or transferred in within the last year, each with the date that membership took effect. Provider, or staff with member_management. No arguments — the full dataset returns in one response. */
  myNewMembers: MyNewMembersSuccess;
  /** Returns the authenticated member's next scheduled payment. */
  myNextPaymentDue: NextPaymentDueType;
  /** Returns the authenticated caller's current notification list. */
  myNotifications: Array<Notification>;
  /** Returns the caller's practice's complete roster of Active/Suspended, non-Scholarship members with an outstanding Annual Wellness Program visit. Provider, or staff with member_management. No arguments — the full dataset returns in one response. */
  myOutstandingAwpMembers: MyOutstandingAwpMembersSuccess;
  /** Returns the caller's practice's Active members 1-60 days past due, excluding company-paid corporate members, most overdue first. Provider, or staff with member_management. No pagination arguments — the full dataset returns in one response. */
  myPastDueMembers: MyPastDueMembersSuccess;
  /** Returns the authenticated member's billing cadence and annual membership fee, or a typed failure when no active payment plan exists. */
  myPaymentPlan: MyPaymentPlanResult;
  /** Returns the authenticated member's payment transaction history. */
  myPaymentTransactions: MyPaymentTransactionsSuccess;
  /** Returns packed CASL rules for the authenticated user. Hydrate client-side with createMongoAbility(rules). */
  myPermissions: MyPermissionsType;
  /** Returns the office of the physician the authenticated member is assigned to. Member accounts only. */
  myPracticeInfo?: Maybe<Practice>;
  /** Returns a page of the caller's practice member list, scoped to their own practiceId. Provider, or staff with member_management. Optionally filtered by status (exact Member_Status__c picklist values: Active, Suspended, Inactive, Survey, Prospecting, Not Interested). */
  myPracticeMembers: MyPracticeMembersSuccess;
  /** Returns the caller's practice's complete roster of Active members renewing within 90 days who are recommended for outreach. Provider, or staff with member_management. No arguments — the full dataset returns in one response. */
  myRecommendedOutreachMembers: MyRecommendedOutreachMembersSuccess;
  /** Returns the authenticated member's saved payment methods. */
  mySavedPaymentMethods: MySavedPaymentMethodsResult;
  /** Returns the caller's practice's complete roster of Active/Suspended members on a Scholarship billing schedule. Provider, or staff with member_management. No arguments — the full dataset returns in one response. */
  myScholarshipMembers: MyScholarshipMembersSuccess;
  /** Returns the caller's practice's complete Suspended member roster. Provider, or staff with member_management. No pagination arguments — the full dataset returns in one response. */
  mySuspendedMembers: MySuspendedMembersSuccess;
  /** Returns the authenticated member's scheduled future one-time payments. */
  myUpcomingPayments: Array<UpcomingPayment>;
  /** Returns the caller's practice's complete roster of Active members with an upcoming renewal. Provider, or staff with member_management. No pagination arguments — the full dataset returns in one response. */
  myUpcomingRenewalMembers: MyUpcomingRenewalMembersSuccess;
  /** Per-vocabulary term counts, dynamic against whatever filter/search is active. Each vocabulary's own active selection is excluded from its own counts; every other active filter and search still narrows them. */
  recipeFacets: Array<RecipeFacetGroup>;
  /** Browses the recipe catalog, with optional taxonomy filters and free-text search. */
  recipes: RecipesSuccess;
  /** Per-topic article counts for the filter panel, recomputed against the active search. */
  wellnessArticleFacets: Array<WellnessArticleFacetValue>;
  /** Browses the wellness article wall, with optional topic filters and free-text search. */
  wellnessArticles: WellnessArticlesSuccess;
};


export type QueryArticleFacetsArgs = {
  input: ArticleFacetsInput;
};


export type QueryArticlesArgs = {
  input: ArticlesInput;
};


export type QueryDownloadPaymentReceiptArgs = {
  paymentId: Scalars['ID']['input'];
};


export type QueryGetArticleByVendorIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetRecipeByVendorIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMemberInfoByContactIdArgs = {
  contactId: Scalars['String']['input'];
};


export type QueryMyAwpVisitsArgs = {
  mostRecent?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyBookmarkedEntityIdsArgs = {
  input: MyBookmarkedEntityIdsInput;
};


export type QueryMyBookmarksArgs = {
  input: MyBookmarksInput;
};


export type QueryMyPaymentTransactionsArgs = {
  input: MyPaymentTransactionsInput;
};


export type QueryMyPracticeMembersArgs = {
  input: MyPracticeMembersInput;
};


export type QueryMySavedPaymentMethodsArgs = {
  input: MySavedPaymentMethodsInput;
};


export type QueryRecipeFacetsArgs = {
  input: RecipeFacetsInput;
};


export type QueryRecipesArgs = {
  input: RecipesInput;
};


export type QueryWellnessArticleFacetsArgs = {
  input: WellnessArticleFacetsInput;
};


export type QueryWellnessArticlesArgs = {
  input: WellnessArticlesInput;
};

/** A recipe's browse/card fields. No ownership — every role reads the same catalog. */
export type Recipe = {
  __typename?: 'Recipe';
  /** Attribution for licensed content. */
  byline?: Maybe<Scalars['String']['output']>;
  /** Vendor's copyright/attribution notice for this item. */
  copyright?: Maybe<Scalars['String']['output']>;
  /** Cuisine taxonomy terms. */
  cuisine: Array<Scalars['String']['output']>;
  /** Short description. */
  description?: Maybe<Scalars['String']['output']>;
  /** Dietary-restriction taxonomy terms. */
  dietaryRestrictions: Array<Scalars['String']['output']>;
  /** Health-consideration taxonomy terms. */
  healthConsiderations: Array<Scalars['String']['output']>;
  /** The vendor's own stable item id — this recipe's external identity. */
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Ingredient groups. */
  ingredients: Array<IngredientGroup>;
  /** Numbered preparation steps, vendor text verbatim. */
  instructions: Array<Scalars['String']['output']>;
  isBookmarked: Scalars['Boolean']['output'];
  /** Main-ingredient taxonomy terms. */
  mainIngredient: Array<Scalars['String']['output']>;
  /** Meal-course taxonomy terms. */
  mealCourse: Array<Scalars['String']['output']>;
  /** Nutrition facts per serving, unfiltered. */
  nutritionFacts: Array<NutritionFact>;
  /** Human-readable prep time, as the vendor renders it. */
  prepTime?: Maybe<Scalars['String']['output']>;
  /** Preparation-technique taxonomy terms. */
  preparationTechnique: Array<Scalars['String']['output']>;
  /** Season/occasion taxonomy terms. */
  seasonOccasion: Array<Scalars['String']['output']>;
  /** Style/theme taxonomy terms. */
  styleThemes: Array<Scalars['String']['output']>;
  /** Recipe title. */
  title: Scalars['String']['output'];
  /** Human-readable total time, as the vendor renders it. */
  totalTime?: Maybe<Scalars['String']['output']>;
  /** Type-of-dish taxonomy terms. */
  typeOfDish: Array<Scalars['String']['output']>;
  /** Recipe yield, e.g. number of servings. */
  yield?: Maybe<Scalars['String']['output']>;
};

/** One vocabulary's term counts. Self-excluding: this vocabulary's own active selection is ignored when computing its counts, but every other active filter/search still applies. */
export type RecipeFacetGroup = {
  __typename?: 'RecipeFacetGroup';
  /** Every term still reachable under the request's other active filters, count descending. */
  values: Array<RecipeFacetValue>;
  /** Which vocabulary these counts belong to. */
  vocabulary: RecipeTaxonomyVocabulary;
};

/** One taxonomy term and how many recipes currently match it. */
export type RecipeFacetValue = {
  __typename?: 'RecipeFacetValue';
  /** Recipes carrying this term, under the request's other filters. */
  count: Scalars['Int']['output'];
  /** The taxonomy term, e.g. "American". */
  term: Scalars['String']['output'];
};

/** Filter and search options for `recipeFacets`. No pagination. */
export type RecipeFacetsInput = {
  /** Match ANY of these cuisine terms. */
  cuisine?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Match ANY of these dietary-restriction terms. */
  dietaryRestrictions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Match ANY of these health-consideration terms. */
  healthConsiderations?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Match ANY of these main-ingredient terms. */
  mainIngredient?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Match ANY of these meal-course terms. */
  mealCourse?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Match ANY of these preparation-technique terms. */
  preparationTechnique?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Free-text search over title/description/byline. Understands quoted phrases and -exclusion. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Match ANY of these season/occasion terms. */
  seasonOccasion?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Match ANY of these style/theme terms. */
  styleThemes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Match ANY of these type-of-dish terms. */
  typeOfDish?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** One of the nine taxonomy vocabularies a recipe can be tagged with. */
export type RecipeTaxonomyVocabulary =
  | 'CUISINE'
  | 'DIETARY_RESTRICTIONS'
  | 'HEALTH_CONSIDERATIONS'
  | 'MAIN_INGREDIENT'
  | 'MEAL_COURSE'
  | 'PREPARATION_TECHNIQUE'
  | 'SEASON_OCCASION'
  | 'STYLE_THEMES'
  | 'TYPE_OF_DISH';

/** Filter, search, and pagination options for `recipes`. */
export type RecipesInput = {
  /** When true, restricts results to recipes the current member has bookmarked. Composes with taxonomy filters and search by AND, not a separate code path. Non-members always get an empty result rather than an error. */
  bookmarkedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Match ANY of these cuisine terms. */
  cuisine?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Match ANY of these dietary-restriction terms. */
  dietaryRestrictions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Match ANY of these health-consideration terms. */
  healthConsiderations?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Pagination — max records to return. Defaults to 20, hard ceiling 100. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Match ANY of these main-ingredient terms. */
  mainIngredient?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Match ANY of these meal-course terms. */
  mealCourse?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Pagination — records to skip. Defaults to 0. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Match ANY of these preparation-technique terms. */
  preparationTechnique?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Free-text search over title/description/byline. Understands quoted phrases and -exclusion. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Match ANY of these season/occasion terms. */
  seasonOccasion?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Match ANY of these style/theme terms. */
  styleThemes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Match ANY of these type-of-dish terms. */
  typeOfDish?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A page of recipes matching `RecipesInput`. */
export type RecipesSuccess = {
  __typename?: 'RecipesSuccess';
  /** Recipes in this page, ordered per the query. */
  edges: Array<Recipe>;
  /** Post-filter count for this page: recipes in `edges`. Equal to `edges.length`. */
  filteredCount: Scalars['Int']['output'];
  /** Echoed `limit` from the request. */
  limit: Scalars['Int']['output'];
  /** Echoed `offset` from the request. */
  offset: Scalars['Int']['output'];
  /** The member's total bookmarked, non-retired recipes — independent of bookmarkedOnly and every other filter on this request. Null means the count failed; check errors[] rather than treating it as zero. */
  savedCount?: Maybe<Scalars['Int']['output']>;
  /** Pre-filter count: total recipes matching this request's filter/search, unbounded by `limit`/`offset`. Reliable pagination stop condition: `offset + limit >= totalCount` — do NOT use `edges.length < limit`. */
  totalCount: Scalars['Int']['output'];
};

/** One prospect whose referral could not be sent. */
export type ReferralRecipientFailure = {
  __typename?: 'ReferralRecipientFailure';
  /** Why this recipient failed. */
  code: SubmitReferralFailureCode;
  /** The address that failed, as submitted. */
  email: Scalars['String']['output'];
};

/** One person being referred. */
export type ReferralRecipientInput = {
  /** The person's email address. */
  email: Scalars['String']['input'];
  /** The person's name, used to personalize their email. */
  name: Scalars['String']['input'];
};

export type RemoveBankAccountFailure = DomainError & {
  __typename?: 'RemoveBankAccountFailure';
  /** Machine-readable failure category. Stable across releases. */
  code: RemoveBankAccountFailureCode;
  /** User-facing message. Safe to display directly. */
  message: Scalars['String']['output'];
};

/** Machine-readable failure category for `removeBankAccount`. Stable across releases — drives client dispatch. */
export type RemoveBankAccountFailureCode =
  | 'DEFAULT_ACCOUNT'
  | 'NOT_FOUND';

/** Input for `removeBankAccount`. Contains only the target `Payment_Profile__c` record ID — ownership is enforced from the JWT-derived session, never from client input. */
export type RemoveBankAccountInput = {
  /** Salesforce `Payment_Profile__c` record ID of the bank account to remove. Must belong to the authenticated member, must be an ACH profile, and must not be the current default. */
  id: Scalars['ID']['input'];
};

/** Typed outcome of `removeBankAccount` — Success on soft-deleted account, Failure on domain-level rejection (NOT_FOUND / DEFAULT_ACCOUNT). Infrastructure errors surface as GraphQL `errors`, not as result variants. */
export type RemoveBankAccountResult = RemoveBankAccountFailure | RemoveBankAccountSuccess;

/** Successful outcome of `removeBankAccount`. Carries the removed account as it now lives in Salesforce (with `isActive = false`). */
export type RemoveBankAccountSuccess = {
  __typename?: 'RemoveBankAccountSuccess';
  /** The removed `Payment_Profile__c` row mapped to the domain `SavedBankAccount` shape. `isActive` will be `false`. */
  account: SavedBankAccount;
};

export type RemoveCreditCardFailure = DomainError & {
  __typename?: 'RemoveCreditCardFailure';
  /** Machine-readable failure category. Stable across releases. */
  code: RemoveCreditCardFailureCode;
  /** User-facing message. Safe to display directly. */
  message: Scalars['String']['output'];
};

/** Machine-readable failure category for `removeCreditCard`. Stable across releases — drives client dispatch. */
export type RemoveCreditCardFailureCode =
  | 'DEFAULT_CARD'
  | 'NOT_FOUND';

/** Input for `removeCreditCard`. Contains only the target `Payment_Profile__c` record ID — ownership is enforced from the JWT-derived session, never from client input. */
export type RemoveCreditCardInput = {
  /** Salesforce `Payment_Profile__c` record ID of the credit card to remove. Must belong to the authenticated member and must not be the current default. */
  id: Scalars['ID']['input'];
};

/** Typed outcome of `removeCreditCard` — Success on soft-deleted card, Failure on domain-level rejection (NOT_FOUND / DEFAULT_CARD). Infrastructure errors surface as GraphQL `errors`, not as result variants. */
export type RemoveCreditCardResult = RemoveCreditCardFailure | RemoveCreditCardSuccess;

/** Successful outcome of `removeCreditCard`. Carries the removed card as it now lives in Salesforce (with `isActive = false`). */
export type RemoveCreditCardSuccess = {
  __typename?: 'RemoveCreditCardSuccess';
  /** The removed `Payment_Profile__c` row mapped to the domain `SavedCreditCard` shape. `isActive` will be `false`. */
  card: SavedCreditCard;
};

/** Entity to remove from one of the caller's lists. */
export type RemoveMyBookmarkInput = {
  /** Opaque id of the entity item to remove. */
  entityId: Scalars['String']['input'];
  /** The type of entity being removed. */
  entityType: BookmarkEntityType;
  /** Which list to remove it from. */
  kind: BookmarkKind;
};

/** Bank-account (ACH) variant of `SavedPaymentMethod`. Sourced from `Payment_Profile__c` rows where `PaymentType__c = 'ACH'`. The full account and routing numbers never leave the payment gateway — only the masked `last6` and the (public) 9-digit routing number are stored and returned. */
export type SavedBankAccount = SavedPaymentMethod & {
  __typename?: 'SavedBankAccount';
  /** Account type — CHECKING | SAVINGS | OTHER (from `ACH_Name_of_Account__c`). */
  accountType: BankAccountType;
  /** Bank name as captured at add time (from `ACHBankName__c`). Null when the SF column is blank — `addBankAccount` always sets it, but legacy or externally-created rows may not. */
  bankName?: Maybe<Scalars['String']['output']>;
  /** Billing address on file. Null when every address field on the profile is blank. */
  billingAddress?: Maybe<BillingAddress>;
  /** Salesforce `Payment_Profile__c` record ID. */
  id: Scalars['ID']['output'];
  /** True if the profile is active (not deactivated) in Salesforce. */
  isActive: Scalars['Boolean']['output'];
  /** True if this payment method is enrolled in autopay. Currently returns `false` as a placeholder — see CNP-169 §6 Q2. */
  isAutoPay: Scalars['Boolean']['output'];
  /** True if this is the member's default payment method. */
  isDefault: Scalars['Boolean']['output'];
  /** True if the account is flagged as an HSA account on the profile. */
  isHSA: Scalars['Boolean']['output'];
  /** Last 5–6 digits of the bank account number (from `ACHLast6__c`). The client owns presentation — render `••••{last6}`, `…1234`, etc. The full account number never leaves the payment gateway. */
  last6: Scalars['String']['output'];
  /** Name on the bank account, if stored (from `Name_on_Card__c`). */
  nameOnAccount?: Maybe<Scalars['String']['output']>;
  /** The 9-digit ABA routing number (from `ACHRoutingLast9__c`). Public bank data, not account-identifying on its own. */
  routingLast9: Scalars['String']['output'];
};

/** Credit-card variant of `SavedPaymentMethod`. Sourced from `Payment_Profile__c` rows where `PaymentType__c ∈ {AMEX, VISA, MC, DISC}`. */
export type SavedCreditCard = SavedPaymentMethod & {
  __typename?: 'SavedCreditCard';
  /** Billing address on file. Null when every address field on the profile is blank. */
  billingAddress?: Maybe<BillingAddress>;
  /** Expiration month, 1–12. */
  expirationMonth: Scalars['Int']['output'];
  /** Expiration year as a 4-digit year (e.g. 2027). */
  expirationYear: Scalars['Int']['output'];
  /** Salesforce `Payment_Profile__c` record ID. */
  id: Scalars['ID']['output'];
  /** True if the profile is active (not deactivated) in Salesforce. */
  isActive: Scalars['Boolean']['output'];
  /** True if this payment method is enrolled in autopay. Currently returns `false` as a placeholder — see CNP-169 §6 Q2. */
  isAutoPay: Scalars['Boolean']['output'];
  /** True if this is the member's default payment method. */
  isDefault: Scalars['Boolean']['output'];
  /** Derived in API from the current UTC year-month — a card is expired only AFTER the last day of its printed expiry month. */
  isExpired: Scalars['Boolean']['output'];
  /** True if the card is flagged as an FSA card. Currently returns `false` as a placeholder — see CNP-169 §6 Q1. */
  isFSA: Scalars['Boolean']['output'];
  /** True if the card is flagged as an HSA card on the profile. */
  isHSA: Scalars['Boolean']['output'];
  /** Last 4 digits of the card PAN, as a 4-character numeric string (e.g. `"1234"`). The client owns presentation — render `•••• •••• •••• {last4}`, `…1234`, etc. The full PAN never leaves the payment gateway. */
  last4: Scalars['String']['output'];
  /** Cardholder name as it appears on the card, if stored. */
  nameOnCard?: Maybe<Scalars['String']['output']>;
  /** Card network — AMEX | VISA | MC | DISC. */
  network: CardNetwork;
};

/** A single saved payment method on file for the authenticated member. Variant-agnostic shape. Implemented by `SavedCreditCard` and `SavedBankAccount` (ACH); digital-wallet variants are planned. Sourced from Salesforce `Payment_Profile__c`. */
export type SavedPaymentMethod = {
  /** Billing address on file. Null when every address field on the profile is blank. */
  billingAddress?: Maybe<BillingAddress>;
  /** Salesforce `Payment_Profile__c` record ID. */
  id: Scalars['ID']['output'];
  /** True if the profile is active (not deactivated) in Salesforce. */
  isActive: Scalars['Boolean']['output'];
  /** True if this payment method is enrolled in autopay. Currently returns `false` as a placeholder — see CNP-169 §6 Q2. */
  isAutoPay: Scalars['Boolean']['output'];
  /** True if this is the member's default payment method. */
  isDefault: Scalars['Boolean']['output'];
};

export type ScheduleOneTimePaymentFailure = DomainError & {
  __typename?: 'ScheduleOneTimePaymentFailure';
  /** Machine-readable failure category. Stable across releases. */
  code: ScheduleOneTimePaymentFailureCode;
  /** User-facing message. Safe to display directly. */
  message: Scalars['String']['output'];
};

/** Machine-readable failure category for `scheduleOneTimePayment`. Stable across releases — drives client dispatch. */
export type ScheduleOneTimePaymentFailureCode =
  | 'AMOUNT_EXCEEDS_MAXIMUM'
  | 'NOT_FOUND';

/** Input for `scheduleOneTimePayment` — schedules a one-time payment toward the member's balance. */
export type ScheduleOneTimePaymentInput = {
  /** Payment amount. Must be greater than 0. */
  amount: Scalars['Float']['input'];
  /** The selected saved payment account's `Payment_Profile__c` id. */
  paymentProfileId: Scalars['ID']['input'];
  /** ISO `yyyy-MM-dd` date the payment should be processed. Must be strictly after today in America/New_York. */
  scheduleDate: Scalars['String']['input'];
  /** Optional origin URL pass-through. */
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  /** Optional origin domain pass-through. */
  webMdDomain?: InputMaybe<Scalars['String']['input']>;
};

/** Typed outcome of `scheduleOneTimePayment` — Success on the created record, Failure on domain-level rejection (`NOT_FOUND`, `AMOUNT_EXCEEDS_MAXIMUM`). Infrastructure and caller errors — including Zod validation failures — surface as GraphQL `errors`, not as result variants. */
export type ScheduleOneTimePaymentResult = ScheduleOneTimePaymentFailure | ScheduleOneTimePaymentSuccess;

/** Successful outcome of `scheduleOneTimePayment`. Carries the created Transaction_Queue__c record's identity. */
export type ScheduleOneTimePaymentSuccess = {
  __typename?: 'ScheduleOneTimePaymentSuccess';
  /** The created `Transaction_Queue__c` record's id. */
  id: Scalars['ID']['output'];
  /** The created `Transaction_Queue__c` record's name. */
  name: Scalars['String']['output'];
};

export type ScholarshipMemberDirectoryEntry = {
  __typename?: 'ScholarshipMemberDirectoryEntry';
  /** Salesforce Account Id of the member's practice. */
  accountId?: Maybe<Scalars['String']['output']>;
  /** Computed age in years. */
  age?: Maybe<Scalars['Float']['output']>;
  /** Balance aged 1-30 days past due. */
  aging30?: Maybe<Scalars['Float']['output']>;
  /** Balance aged 31-60 days past due. */
  aging60?: Maybe<Scalars['Float']['output']>;
  /** Balance aged 61-90 days past due. */
  aging90?: Maybe<Scalars['Float']['output']>;
  /** Balance aged 91-120+ days past due. */
  aging120?: Maybe<Scalars['Float']['output']>;
  /** Current (not-yet-due) balance. */
  agingCurrent?: Maybe<Scalars['Float']['output']>;
  /** Membership MSRP amount. */
  amountMsrp?: Maybe<Scalars['Float']['output']>;
  /** Whether AutoPay is enabled. */
  autoPay?: Maybe<Scalars['Boolean']['output']>;
  /** Whether billing routes to a national account. */
  billToNationalAccount?: Maybe<Scalars['Boolean']['output']>;
  /** Number of days the balance is past due. */
  billingDaysPastDue?: Maybe<Scalars['Float']['output']>;
  /** Whether the member can be sent a secure message. Derived from a mailbox id that is never exposed raw; null on a read that did not select it. */
  canSendMessage?: Maybe<Scalars['Boolean']['output']>;
  /** Current agreement MSRP (annual fee). */
  currentAgreementMsrp?: Maybe<Scalars['Float']['output']>;
  /** Current agreement payment schedule. */
  currentAgreementPaymentSchedule?: Maybe<Scalars['String']['output']>;
  /** Current balance (formula field). */
  currentBalanceFormula?: Maybe<Scalars['Float']['output']>;
  /** Current membership type. */
  currentMembershipType?: Maybe<Scalars['String']['output']>;
  /** Date of birth (yyyy-MM-dd). */
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  /** Date of the oldest unpaid invoice (yyyy-MM-dd). */
  dateOfOldestUnpaidInvoice?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** Emergency contact phone number. */
  emergencyPhone?: Maybe<Scalars['String']['output']>;
  /** Employer name. */
  employer?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** Gender. */
  gender?: Maybe<Gender>;
  /** Salesforce Contact Id. */
  id: Scalars['ID']['output'];
  /** Insurance carrier name from the member's Insurance lookup — distinct from primaryInsurance, which is a separate free-text field. */
  insuranceName?: Maybe<Scalars['String']['output']>;
  isHealthChampion: Scalars['Boolean']['output'];
  /** Job title. */
  jobTitle?: Maybe<Scalars['String']['output']>;
  /** Date of the member's last wellness exam (yyyy-MM-dd). */
  lastAwpDate?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** Amount of the member's last payment. */
  lastPaymentAmount?: Maybe<Scalars['Float']['output']>;
  /** Date of the member's last payment (yyyy-MM-dd). */
  lastPaymentDate?: Maybe<Scalars['String']['output']>;
  mailingAddress?: Maybe<PostalAddress>;
  /** MDVIP member Id. */
  mdvipId?: Maybe<Scalars['String']['output']>;
  /** Date the member's current membership was established (yyyy-MM-dd). */
  memberSince?: Maybe<Scalars['String']['output']>;
  /** Membership status. */
  memberStatus?: Maybe<Scalars['String']['output']>;
  /** Mobile phone number. */
  mobilePhone?: Maybe<Scalars['String']['output']>;
  /** Name of the corporate account billed for this member, if any. */
  nationalAccountName?: Maybe<Scalars['String']['output']>;
  /** Computed next-birthday date (yyyy-MM-dd). */
  nextBirthday?: Maybe<Scalars['String']['output']>;
  otherAddress?: Maybe<PostalAddress>;
  phone?: Maybe<Scalars['String']['output']>;
  /** Preferred method of communication. */
  preferredContactMethod?: Maybe<PreferredContactMethod>;
  /** Primary insurance company name. */
  primaryInsurance?: Maybe<Scalars['String']['output']>;
  /** SAS-signed URL for the member's profile photo, or null if a SAS could not be minted. When non-null, it always resolves to a URL whether or not a photo has been uploaded yet — a 404 on that URL is the no-photo signal. */
  profilePhotoUrl?: Maybe<ProfilePhotoUrl>;
  /** Computed membership renewal date (yyyy-MM-dd). */
  renewalDate?: Maybe<Scalars['String']['output']>;
  /** Salutation / title (e.g. Mr., Dr.). */
  salutation?: Maybe<Scalars['String']['output']>;
  /** Date the member's scholarship ends (yyyy-MM-dd). */
  scholarshipEndDate?: Maybe<Scalars['String']['output']>;
  /** Secondary insurance company name. */
  secondaryInsurance?: Maybe<Scalars['String']['output']>;
  /** Which servicing arrangement covers the member's membership. Resolved on the member's own read; null on reads that do not project it. */
  serviceState?: Maybe<MemberServiceState>;
  /** Work phone number. */
  workPhone?: Maybe<Scalars['String']['output']>;
};

export type SendPaymentReceiptEmailFailure = DomainError & {
  __typename?: 'SendPaymentReceiptEmailFailure';
  /** Machine-readable failure category. Stable across releases. */
  code: SendPaymentReceiptEmailFailureCode;
  /** User-facing message. Safe to display directly. */
  message: Scalars['String']['output'];
};

/** Machine-readable failure category for `sendPaymentReceiptEmail`. Stable across releases — drives client dispatch. */
export type SendPaymentReceiptEmailFailureCode =
  | 'FAILED'
  | 'NOT_FOUND';

/** Typed outcome of `sendPaymentReceiptEmail` — Success on the destination email, Failure on domain-level rejection (`NOT_FOUND`, `FAILED`). Infrastructure and caller errors surface as GraphQL `errors`, not as result variants. */
export type SendPaymentReceiptEmailResult = SendPaymentReceiptEmailFailure | SendPaymentReceiptEmailSuccess;

/** Successful outcome of `sendPaymentReceiptEmail`. Carries the address the receipt was sent to. */
export type SendPaymentReceiptEmailSuccess = {
  __typename?: 'SendPaymentReceiptEmailSuccess';
  /** Address the receipt was emailed to. */
  email: Scalars['String']['output'];
};

export type SetDefaultPaymentMethodFailure = DomainError & {
  __typename?: 'SetDefaultPaymentMethodFailure';
  /** Machine-readable failure category. Stable across releases. */
  code: SetDefaultPaymentMethodFailureCode;
  /** User-facing message. Safe to display directly. */
  message: Scalars['String']['output'];
};

/** Machine-readable failure category for `setDefaultPaymentMethod`. Stable across releases — drives client dispatch. */
export type SetDefaultPaymentMethodFailureCode =
  | 'NOT_FOUND';

/** Typed outcome of `setDefaultPaymentMethod` — Success on the record now flagged default, Failure on domain-level rejection (`NOT_FOUND`). Infrastructure and caller errors surface as GraphQL `errors`, not as result variants. */
export type SetDefaultPaymentMethodResult = SetDefaultPaymentMethodFailure | SetDefaultPaymentMethodSuccess;

/** Successful outcome of `setDefaultPaymentMethod`. No re-read — the input id and the fact that the PATCH didn't throw are sufficient to report `isDefault: true`. */
export type SetDefaultPaymentMethodSuccess = {
  __typename?: 'SetDefaultPaymentMethodSuccess';
  /** Salesforce `Payment_Profile__c` record ID that was set default. */
  id: Scalars['ID']['output'];
  /** Always `true` on success. */
  isDefault: Scalars['Boolean']['output'];
};

export type SubmitContactUsRequestFailure = DomainError & {
  __typename?: 'SubmitContactUsRequestFailure';
  /** Machine-readable failure category. Stable across releases. */
  code: SubmitContactUsRequestFailureCode;
  /** User-facing message. Safe to display directly. */
  message: Scalars['String']['output'];
};

/** Machine-readable failure category for `submitContactUsRequest`. Stable across releases — drives client dispatch. */
export type SubmitContactUsRequestFailureCode =
  | 'INVALID_CATEGORY'
  | 'SEND_FAILED';

/** Input for `submitContactUsRequest`. Carries a category key and the member's own form fields — never a recipient address, subject, or body. */
export type SubmitContactUsRequestInput = {
  /** Must be `true` — the submitter's confirmation that the message contains no protected health information. */
  agreedToPhiDisclaimer: Scalars['Boolean']['input'];
  /** Best phone number to reach the submitter. */
  callbackNumber: Scalars['String']['input'];
  /** `ContactUsCategory.key` the request is being filed under. */
  categoryKey: Scalars['String']['input'];
  /** Submitter's email. Receives the confirmation copy. */
  email: Scalars['String']['input'];
  /** Free-text message. Max 4000 characters, enforced server-side. */
  message: Scalars['String']['input'];
  /** Submitter's name, as entered. */
  name: Scalars['String']['input'];
};

/** Typed outcome of `submitContactUsRequest` — Success on the filed category, Failure on domain-level rejection (`INVALID_CATEGORY`, `SEND_FAILED`). Infrastructure and caller errors, including Zod validation failures, surface as GraphQL `errors`, not as result variants. */
export type SubmitContactUsRequestResult = SubmitContactUsRequestFailure | SubmitContactUsRequestSuccess;

/** Successful outcome of `submitContactUsRequest`. Carries the category key back so the client can look up the matching success copy it already holds. */
export type SubmitContactUsRequestSuccess = {
  __typename?: 'SubmitContactUsRequestSuccess';
  /** The category the request was filed under. */
  categoryKey: Scalars['String']['output'];
};

export type SubmitReferralFailure = DomainError & {
  __typename?: 'SubmitReferralFailure';
  /** Machine-readable failure category. Stable across releases. */
  code: SubmitReferralFailureCode;
  /** User-facing message. Safe to display directly. */
  message: Scalars['String']['output'];
};

/** Machine-readable failure category for `submitReferral`. Stable across releases — drives client dispatch. */
export type SubmitReferralFailureCode =
  | 'PHYSICIAN_UNAVAILABLE'
  | 'SEND_FAILED';

/** Input for `submitReferral`. The referring member's own name and email are editable; the physician's name is resolved server-side from their practice and cannot be supplied. */
export type SubmitReferralInput = {
  /** People to refer. At least one, at most five, no duplicate email addresses within a submission, and none equal to `referrerEmail`. */
  recipients: Array<ReferralRecipientInput>;
  /** Referring member's email. Receives the confirmation, and may not also appear in `recipients`. */
  referrerEmail: Scalars['String']['input'];
  /** Referring member's name, prefilled from their profile but editable. */
  referrerName: Scalars['String']['input'];
};

/** Typed outcome of `submitReferral` — Success (possibly partial, see `failed`) or Failure when the submission could not be attempted at all. Infrastructure and caller errors, including Zod validation failures, surface as GraphQL `errors`. */
export type SubmitReferralResult = SubmitReferralFailure | SubmitReferralSuccess;

/** Outcome of `submitReferral`. `failed` is empty on a clean run; a non-empty list means some referrals went out and some did not. */
export type SubmitReferralSuccess = {
  __typename?: 'SubmitReferralSuccess';
  /** Whether the referring member received their confirmation. False when any prospect failed — the member is not told 'your email has been sent' when it partly was not. */
  confirmationSent: Scalars['Boolean']['output'];
  /** Prospects whose referral failed. Empty on a clean run. */
  failed: Array<ReferralRecipientFailure>;
  /** How many referrals were sent. */
  sentCount: Scalars['Int']['output'];
};

/** Domain transaction type — PAYMENT | PAYMENT_REVERSAL | CREDIT_MEMO | REFUND. Mapped from the Salesforce `Type__c` picklist; no `__c` past the mapper. */
export type TransactionType =
  | 'CREDIT_MEMO'
  | 'PAYMENT'
  | 'PAYMENT_REVERSAL'
  | 'REFUND';

/** A single scheduled future one-time payment on the authenticated member's account. Sourced from Salesforce `Transaction_Queue__c`. */
export type UpcomingPayment = {
  __typename?: 'UpcomingPayment';
  /** Classification of the payment method behind this scheduled payment. */
  accountKind: PaymentAccountKind;
  /** Trailing digits identifying the account — `CCLast4__c` for `CARD`, `ACHLast6__c` for `BANK`. Length varies by kind; null for `CHECK`/`REMOVED`/`UNKNOWN`. */
  accountSuffix?: Maybe<Scalars['String']['output']>;
  /** Payment amount (e.g. 750.00). */
  amount: Scalars['Float']['output'];
  /** Bank name for the linked account, sourced from `ACHBankName__c`. Present only when `accountKind` is `BANK`. */
  bankName?: Maybe<Scalars['String']['output']>;
  /** Expiration month, 1–12. Present only when `accountKind` is `CARD`. */
  expirationMonth?: Maybe<Scalars['Int']['output']>;
  /** Expiration year. Present only when `accountKind` is `CARD`. */
  expirationYear?: Maybe<Scalars['Int']['output']>;
  /** Salesforce `Transaction_Queue__c` record ID. */
  id: Scalars['ID']['output'];
  /** Card network, present only when `accountKind` is `CARD`. Null when the brand value on the linked profile isn't a recognized network — the row is still returned, never dropped. */
  network?: Maybe<CardNetwork>;
  /** Salesforce `Payment_Profile__c` record ID this payment is scheduled against, when linked (null for a `REMOVED` row). Not guaranteed to have a matching row in `mySavedPaymentMethods` — that query's own filters and pagination can exclude a profile that appears here. Callers must treat 'no match found' as expected, not an error. */
  paymentProfileId?: Maybe<Scalars['ID']['output']>;
  /** Estimated payment date, ISO `yyyy-MM-dd` (Salesforce `Schedule_Date__c`). */
  scheduledDate: Scalars['String']['output'];
  /** Status of the scheduled payment. */
  status: UpcomingPaymentStatus;
};

/** Status of a scheduled upcoming payment. UNKNOWN means the Salesforce status value didn't map to a known member — a data-integrity gap, not a normal state. */
export type UpcomingPaymentStatus =
  | 'PENDING_PROCESSING'
  | 'RESCHEDULED_CHARGE_REJECTED'
  | 'SCHEDULED'
  | 'UNKNOWN';

/** Input for `updateMyMemberInfo`. Every optional field is three-state: omit it to leave the existing Salesforce value unchanged, pass null to clear it, or pass a value to overwrite it. An empty string is not a clear signal and is rejected — send null instead. FirstName/LastName are not editable and have no corresponding field here. */
export type UpdateMyMemberInfoInput = {
  /** Date of birth, ISO yyyy-MM-dd. */
  dateOfBirth: Scalars['String']['input'];
  /** Email address. */
  email: Scalars['String']['input'];
  /** Emergency contact phone number. Formatting is stripped; must be 10 digits. */
  emergencyPhone?: InputMaybe<Scalars['String']['input']>;
  /** Employer name. */
  employer?: InputMaybe<Scalars['String']['input']>;
  /** Gender. */
  gender: Gender;
  /** Job title. */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Mailing address city. Max 40 characters. */
  mailingCity: Scalars['String']['input'];
  /** Mailing address, first line. Max 100 characters; max 150 combined with `mailingLine2`. */
  mailingLine1: Scalars['String']['input'];
  /** Mailing address, second line (suite, apt, etc.). Omit or pass null when there is no second line. Max 100 characters; max 150 combined with `mailingLine1`. */
  mailingLine2?: InputMaybe<Scalars['String']['input']>;
  /** Mailing address ZIP code — 5 digits or ZIP+4 (12345-6789). */
  mailingPostalCode: Scalars['String']['input'];
  /** Mailing address state. Max 80 characters. */
  mailingState: Scalars['String']['input'];
  /** Mobile phone number. Formatting is stripped; must be 10 digits. */
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  /** Secondary address city. Max 40 characters. */
  otherCity?: InputMaybe<Scalars['String']['input']>;
  /** Secondary address, first line. Must be set (or nulled) together with otherCity/otherState/otherPostalCode. Max 100 characters; max 150 combined with `otherLine2`. */
  otherLine1?: InputMaybe<Scalars['String']['input']>;
  /** Secondary address, second line (suite, apt, etc.). Omit or pass null when there is no second line; cannot be set unless otherLine1 is also present in the same request. Max 100 characters; max 150 combined with `otherLine1`. */
  otherLine2?: InputMaybe<Scalars['String']['input']>;
  /** Secondary address ZIP / postal code. Free-text, max 20 characters. */
  otherPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** Secondary address state. Max 80 characters. */
  otherState?: InputMaybe<Scalars['String']['input']>;
  /** Primary phone number. Formatting is stripped; must be 10 digits. */
  phone: Scalars['String']['input'];
  /** Preferred method of contact. */
  preferredContactMethod?: InputMaybe<PreferredContactMethod>;
  /** Primary insurance company name. */
  primaryInsurance?: InputMaybe<Scalars['String']['input']>;
  /** Salutation / honorific. Salesforce stores this as a picklist whose values in use carry no trailing period — `Mr`, `Mrs`, `Miss`, `Ms`, `Dr`. Max 20 characters. */
  salutation?: InputMaybe<Scalars['String']['input']>;
  /** Secondary insurance company name. */
  secondaryInsurance?: InputMaybe<Scalars['String']['input']>;
  /** Work phone number. Formatting is stripped; must be 10 digits. */
  workPhone?: InputMaybe<Scalars['String']['input']>;
};

/** Successful outcome of `updateMyMemberInfo`. Carries the caller's own Member record as it now lives in Salesforce after the PATCH + re-read. */
export type UpdateMyMemberInfoSuccess = {
  __typename?: 'UpdateMyMemberInfoSuccess';
  /** The caller's own Member record, freshly re-read after the write. */
  member: Member;
};

/** The type of user in the system */
export type UserType =
  | 'MEMBER'
  | 'PROVIDER'
  | 'STAFF';

/** Machine-readable failure category for `verifyBankAccountInformation`. Stable across releases — drives client dispatch. */
export type VerifyBankAccountFailureCode =
  | 'DECLINED'
  | 'UNSUPPORTED_ACCOUNT';

export type VerifyBankAccountInformationFailure = DomainError & {
  __typename?: 'VerifyBankAccountInformationFailure';
  /** Machine-readable failure category. Stable across releases. */
  code: VerifyBankAccountFailureCode;
  /** User-facing message. Safe to display directly. */
  message: Scalars['String']['output'];
};

/** Typed outcome of `verifyBankAccountInformation` — Success on tokenization, Failure on decline or unsupported account. Infrastructure errors surface as GraphQL `errors`, not as result variants. */
export type VerifyBankAccountInformationResult = VerifyBankAccountInformationFailure | VerifyBankAccountInformationSuccess;

export type VerifyBankAccountInformationSuccess = {
  __typename?: 'VerifyBankAccountInformationSuccess';
  /** Authorization transaction ID returned by the gateway. */
  authTransactionId: Scalars['String']['output'];
  /** Token ID returned by the payment gateway for the verified bank account. */
  gatewayTokenId: Scalars['String']['output'];
  /** Payment-method type of the tokenized account. Always `ACH` on this path. */
  paymentType: BankAccountPaymentType;
};

export type VerifyBankAccountInput = {
  /** Bank account number — 4 to 17 digits. Embedded whitespace is stripped at the boundary. Never persisted or returned. */
  accountNumber: Scalars['String']['input'];
  /** ABA routing number — 9 digits with a valid check digit. Embedded whitespace is stripped at the boundary. */
  routingNumber: Scalars['String']['input'];
};

/** Machine-readable failure category for `verifyCreditCardInformation`. Stable across releases — drives client dispatch. */
export type VerifyCreditCardFailureCode =
  | 'DECLINED'
  | 'UNSUPPORTED_NETWORK';

export type VerifyCreditCardInformationFailure = DomainError & {
  __typename?: 'VerifyCreditCardInformationFailure';
  /** Machine-readable failure category. Stable across releases. */
  code: VerifyCreditCardFailureCode;
  /** User-facing message. Safe to display directly. */
  message: Scalars['String']['output'];
};

export type VerifyCreditCardInformationInput = {
  /** Card verification value. 3 digits for most networks; 4 digits for AMEX. */
  CVV: Scalars['String']['input'];
  /** Credit card number. AMEX (BINs 34/37) is 15 digits; all other networks are 16 digits. Embedded whitespace is stripped at the boundary. */
  CardNumber: Scalars['String']['input'];
  /** Expiration month, 1–12. */
  ExpirationMonth: Scalars['Int']['input'];
  /** Expiration year as a 4-digit year (e.g. 2027). Combined with ExpirationMonth, the expiration must be in the current month or later. */
  ExpirationYear: Scalars['Int']['input'];
};

/** Typed outcome of `verifyCreditCardInformation` — Success on tokenization, Failure on decline or unsupported network. Infrastructure errors surface as GraphQL `errors`, not as result variants. */
export type VerifyCreditCardInformationResult = VerifyCreditCardInformationFailure | VerifyCreditCardInformationSuccess;

export type VerifyCreditCardInformationSuccess = {
  __typename?: 'VerifyCreditCardInformationSuccess';
  /** Authorization transaction ID returned by the gateway. */
  authTransactionId: Scalars['String']['output'];
  /** Token ID returned by the payment gateway for the verified credit card. */
  gatewayTokenId: Scalars['String']['output'];
  /** Card network determined by the gateway response (AMEX | VISA | MC | DISC). */
  network: CardNetwork;
};

/** A wellness article's browse fields. No ownership — every role reads the same catalog. */
export type WellnessArticle = {
  __typename?: 'WellnessArticle';
  /** The vendor's canonical page. */
  articleUrl?: Maybe<Scalars['String']['output']>;
  /** Attribution line. */
  attribution?: Maybe<Scalars['String']['output']>;
  /** Short summary. */
  blurb?: Maybe<Scalars['String']['output']>;
  /** Author line. */
  byline?: Maybe<Scalars['String']['output']>;
  /** Copyright notice, displayed verbatim. */
  copyright?: Maybe<Scalars['String']['output']>;
  /** The vendor's own stable item id — this article's external identity. */
  id: Scalars['ID']['output'];
  /** Caption for `imageUrl`. */
  imageCutLine?: Maybe<Scalars['String']['output']>;
  /** The vendor's own image URL, hotlinked rather than re-hosted. */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** When the vendor published it. */
  postingDate?: Maybe<Scalars['Date']['output']>;
  /** Article headline. */
  title: Scalars['String']['output'];
  /** Raw vendor topic codes. Resolving them to labels is a frontend concern. */
  topics: Array<Scalars['String']['output']>;
};

/** One topic code and how many articles carry it. */
export type WellnessArticleFacetValue = {
  __typename?: 'WellnessArticleFacetValue';
  /** Articles carrying this code under the active search. */
  count: Scalars['Int']['output'];
  /** The raw vendor topic code. Resolving it to a label is a frontend concern. */
  term: Scalars['String']['output'];
};

/** Filter and search options for `wellnessArticleFacets`. No pagination. */
export type WellnessArticleFacetsInput = {
  /** Free-text search over title, blurb, byline and body. Understands quoted phrases and -exclusion. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Match articles carrying ANY of these topic codes. */
  topics?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Filter, search, and pagination options for `wellnessArticles`. */
export type WellnessArticlesInput = {
  /** Pagination — max records to return. Defaults to 20, hard ceiling 100. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Pagination — records to skip. Defaults to 0. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Free-text search over title, blurb, byline and body. Understands quoted phrases and -exclusion. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Match articles carrying ANY of these topic codes. */
  topics?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A page of wellness articles matching `WellnessArticlesInput`. */
export type WellnessArticlesSuccess = {
  __typename?: 'WellnessArticlesSuccess';
  /** Articles in this page, ordered per the query. */
  edges: Array<WellnessArticle>;
  /** Post-filter count for this page: articles in `edges`. Equal to `edges.length`. */
  filteredCount: Scalars['Int']['output'];
  /** Echoed `limit` from the request. */
  limit: Scalars['Int']['output'];
  /** Echoed `offset` from the request. */
  offset: Scalars['Int']['output'];
  /** Pre-filter count: total articles matching this request's filter/search, unbounded by `limit`/`offset`. Reliable pagination stop condition: `offset + limit >= totalCount` — do NOT use `edges.length < limit`. */
  totalCount: Scalars['Int']['output'];
};

export type MemberInfoByContactIdQueryVariables = Exact<{
  contactId: Scalars['String']['input'];
}>;


export type MemberInfoByContactIdQuery = { __typename?: 'Query', memberInfoByContactId?: { __typename?: 'Member', id: string, firstName?: string | null, lastName?: string | null, mdvipId?: string | null, dateOfBirth?: string | null } | null };

export type MyActiveMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type MyActiveMembersQuery = { __typename?: 'Query', myActiveMembers: { __typename?: 'MyActiveMembersSuccess', edges: Array<{ __typename?: 'MemberDirectoryEntry', id: string, firstName?: string | null, lastName?: string | null, mdvipId?: string | null, dateOfBirth?: string | null, memberSince?: string | null, phone?: string | null, mobilePhone?: string | null, email?: string | null, memberStatus?: string | null, lastAwpDate?: string | null, renewalDate?: string | null, age?: number | null, nextBirthday?: string | null, insuranceName?: string | null, currentAgreementPaymentSchedule?: string | null, currentAgreementMsrp?: number | null, autoPay?: boolean | null, lastPaymentDate?: string | null, lastPaymentAmount?: number | null, currentBalanceFormula?: number | null, billingDaysPastDue?: number | null, billToNationalAccount?: boolean | null, nationalAccountName?: string | null, isHealthChampion: boolean }> } };

export type MyIppeCalculationMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type MyIppeCalculationMembersQuery = { __typename?: 'Query', myIppeCalculationMembers: { __typename?: 'MyIppeCalculationMembersSuccess', edges: Array<{ __typename?: 'IppeCalculationMemberDirectoryEntry', id: string, firstName?: string | null, lastName?: string | null, mdvipId?: string | null, dateOfBirth?: string | null, memberSince?: string | null, phone?: string | null, mobilePhone?: string | null, email?: string | null, memberStatus?: string | null, lastAwpDate?: string | null, renewalDate?: string | null, currentAgreementPaymentSchedule?: string | null, currentAgreementMsrp?: number | null, autoPay?: boolean | null, lastPaymentDate?: string | null, lastPaymentAmount?: number | null, currentBalanceFormula?: number | null, billingDaysPastDue?: number | null, billToNationalAccount?: boolean | null, nationalAccountName?: string | null, isHealthChampion: boolean, salutation?: string | null, suggestedStartDate?: string | null, suggestedEndDate?: string | null }> } };

export type MyOutstandingAwpMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type MyOutstandingAwpMembersQuery = { __typename?: 'Query', myOutstandingAwpMembers: { __typename?: 'MyOutstandingAwpMembersSuccess', edges: Array<{ __typename?: 'MemberDirectoryEntry', id: string, firstName?: string | null, lastName?: string | null, mdvipId?: string | null, dateOfBirth?: string | null, memberSince?: string | null, phone?: string | null, mobilePhone?: string | null, email?: string | null, memberStatus?: string | null, lastAwpDate?: string | null, renewalDate?: string | null, currentAgreementPaymentSchedule?: string | null, currentAgreementMsrp?: number | null, autoPay?: boolean | null, lastPaymentDate?: string | null, lastPaymentAmount?: number | null, currentBalanceFormula?: number | null, billingDaysPastDue?: number | null, billToNationalAccount?: boolean | null, nationalAccountName?: string | null, isHealthChampion: boolean, mailingAddress?: { __typename?: 'PostalAddress', line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null }> } };

export type MyPastDueMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type MyPastDueMembersQuery = { __typename?: 'Query', myPastDueMembers: { __typename?: 'MyPastDueMembersSuccess', edges: Array<{ __typename?: 'PastDueMemberDirectoryEntry', id: string, firstName?: string | null, lastName?: string | null, mdvipId?: string | null, dateOfBirth?: string | null, memberSince?: string | null, phone?: string | null, mobilePhone?: string | null, email?: string | null, memberStatus?: string | null, lastAwpDate?: string | null, renewalDate?: string | null, currentAgreementPaymentSchedule?: string | null, currentAgreementMsrp?: number | null, autoPay?: boolean | null, lastPaymentDate?: string | null, lastPaymentAmount?: number | null, currentBalanceFormula?: number | null, billingDaysPastDue?: number | null, billToNationalAccount?: boolean | null, nationalAccountName?: string | null, isHealthChampion: boolean, salutation?: string | null, agingCurrent?: number | null, aging30?: number | null, aging60?: number | null, aging90?: number | null, aging120?: number | null, ccDeclineCall?: string | null, ccDeclineLetter?: string | null, dunCall1?: string | null, dunCall2?: string | null, dunCall3?: string | null, dunCall4?: string | null, dunLetter1?: string | null, dunLetter2?: string | null, dunLetter3?: string | null, dunLetter4?: string | null, dunEmail1?: string | null, dunEmail2?: string | null, dunEmail3?: string | null, dunEmail4?: string | null, lastCancelReason?: string | null, mailingAddress?: { __typename?: 'PostalAddress', line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null }> } };

export type MyPracticeMembersQueryVariables = Exact<{
  input: MyPracticeMembersInput;
}>;


export type MyPracticeMembersQuery = { __typename?: 'Query', myPracticeMembers: { __typename?: 'MyPracticeMembersSuccess', totalCount: number, edges: Array<{ __typename?: 'Member', id: string, firstName?: string | null, lastName?: string | null, mdvipId?: string | null, dateOfBirth?: string | null }> } };

export type MyRecommendedOutreachMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type MyRecommendedOutreachMembersQuery = { __typename?: 'Query', myRecommendedOutreachMembers: { __typename?: 'MyRecommendedOutreachMembersSuccess', edges: Array<{ __typename?: 'MemberDirectoryEntry', id: string, firstName?: string | null, lastName?: string | null, mdvipId?: string | null, dateOfBirth?: string | null, memberSince?: string | null, phone?: string | null, mobilePhone?: string | null, email?: string | null, memberStatus?: string | null, lastAwpDate?: string | null, renewalDate?: string | null, currentAgreementPaymentSchedule?: string | null, currentAgreementMsrp?: number | null, autoPay?: boolean | null, lastPaymentDate?: string | null, lastPaymentAmount?: number | null, currentBalanceFormula?: number | null, billingDaysPastDue?: number | null, billToNationalAccount?: boolean | null, nationalAccountName?: string | null, isHealthChampion: boolean, salutation?: string | null }> } };

export type MyScholarshipMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type MyScholarshipMembersQuery = { __typename?: 'Query', myScholarshipMembers: { __typename?: 'MyScholarshipMembersSuccess', edges: Array<{ __typename?: 'ScholarshipMemberDirectoryEntry', id: string, firstName?: string | null, lastName?: string | null, mdvipId?: string | null, dateOfBirth?: string | null, memberSince?: string | null, phone?: string | null, mobilePhone?: string | null, email?: string | null, memberStatus?: string | null, lastAwpDate?: string | null, renewalDate?: string | null, currentAgreementPaymentSchedule?: string | null, billToNationalAccount?: boolean | null, isHealthChampion: boolean, nextBirthday?: string | null, insuranceName?: string | null, scholarshipEndDate?: string | null, mailingAddress?: { __typename?: 'PostalAddress', line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null }> } };

export type MySuspendedMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type MySuspendedMembersQuery = { __typename?: 'Query', mySuspendedMembers: { __typename?: 'MySuspendedMembersSuccess', edges: Array<{ __typename?: 'MemberDirectoryEntry', id: string, firstName?: string | null, lastName?: string | null, mdvipId?: string | null, dateOfBirth?: string | null, memberSince?: string | null, phone?: string | null, mobilePhone?: string | null, email?: string | null, memberStatus?: string | null, lastAwpDate?: string | null, renewalDate?: string | null, currentAgreementPaymentSchedule?: string | null, currentAgreementMsrp?: number | null, autoPay?: boolean | null, lastPaymentDate?: string | null, lastPaymentAmount?: number | null, currentBalanceFormula?: number | null, billingDaysPastDue?: number | null, billToNationalAccount?: boolean | null, nationalAccountName?: string | null, isHealthChampion: boolean, agingCurrent?: number | null, aging30?: number | null, aging60?: number | null, aging90?: number | null, aging120?: number | null }> } };

export type MyUpcomingRenewalMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type MyUpcomingRenewalMembersQuery = { __typename?: 'Query', myUpcomingRenewalMembers: { __typename?: 'MyUpcomingRenewalMembersSuccess', edges: Array<{ __typename?: 'MemberDirectoryEntry', id: string, firstName?: string | null, lastName?: string | null, mdvipId?: string | null, dateOfBirth?: string | null, memberSince?: string | null, phone?: string | null, mobilePhone?: string | null, email?: string | null, memberStatus?: string | null, lastAwpDate?: string | null, renewalDate?: string | null, currentAgreementPaymentSchedule?: string | null, currentAgreementMsrp?: number | null, autoPay?: boolean | null, lastPaymentDate?: string | null, lastPaymentAmount?: number | null, currentBalanceFormula?: number | null, billingDaysPastDue?: number | null, billToNationalAccount?: boolean | null, nationalAccountName?: string | null, isHealthChampion: boolean, mailingAddress?: { __typename?: 'PostalAddress', line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null }> } };

export type ClevelandHeartLabSessionUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type ClevelandHeartLabSessionUrlQuery = { __typename?: 'Query', clevelandHeartlabSessionUrl?: string | null };


export const MemberInfoByContactIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MemberInfoByContactId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberInfoByContactId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contactId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"mdvipId"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}}]}}]}}]} as unknown as DocumentNode<MemberInfoByContactIdQuery, MemberInfoByContactIdQueryVariables>;
export const MyActiveMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyActiveMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myActiveMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"mdvipId"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"memberSince"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"memberStatus"}},{"kind":"Field","name":{"kind":"Name","value":"lastAwpDate"}},{"kind":"Field","name":{"kind":"Name","value":"renewalDate"}},{"kind":"Field","name":{"kind":"Name","value":"age"}},{"kind":"Field","name":{"kind":"Name","value":"nextBirthday"}},{"kind":"Field","name":{"kind":"Name","value":"insuranceName"}},{"kind":"Field","name":{"kind":"Name","value":"currentAgreementPaymentSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"currentAgreementMsrp"}},{"kind":"Field","name":{"kind":"Name","value":"autoPay"}},{"kind":"Field","name":{"kind":"Name","value":"lastPaymentDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastPaymentAmount"}},{"kind":"Field","name":{"kind":"Name","value":"currentBalanceFormula"}},{"kind":"Field","name":{"kind":"Name","value":"billingDaysPastDue"}},{"kind":"Field","name":{"kind":"Name","value":"billToNationalAccount"}},{"kind":"Field","name":{"kind":"Name","value":"nationalAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"isHealthChampion"}}]}}]}}]}}]} as unknown as DocumentNode<MyActiveMembersQuery, MyActiveMembersQueryVariables>;
export const MyIppeCalculationMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyIppeCalculationMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myIppeCalculationMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"mdvipId"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"memberSince"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"memberStatus"}},{"kind":"Field","name":{"kind":"Name","value":"lastAwpDate"}},{"kind":"Field","name":{"kind":"Name","value":"renewalDate"}},{"kind":"Field","name":{"kind":"Name","value":"currentAgreementPaymentSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"currentAgreementMsrp"}},{"kind":"Field","name":{"kind":"Name","value":"autoPay"}},{"kind":"Field","name":{"kind":"Name","value":"lastPaymentDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastPaymentAmount"}},{"kind":"Field","name":{"kind":"Name","value":"currentBalanceFormula"}},{"kind":"Field","name":{"kind":"Name","value":"billingDaysPastDue"}},{"kind":"Field","name":{"kind":"Name","value":"billToNationalAccount"}},{"kind":"Field","name":{"kind":"Name","value":"nationalAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"isHealthChampion"}},{"kind":"Field","name":{"kind":"Name","value":"salutation"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedEndDate"}}]}}]}}]}}]} as unknown as DocumentNode<MyIppeCalculationMembersQuery, MyIppeCalculationMembersQueryVariables>;
export const MyOutstandingAwpMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyOutstandingAwpMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myOutstandingAwpMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"mdvipId"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"memberSince"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"memberStatus"}},{"kind":"Field","name":{"kind":"Name","value":"lastAwpDate"}},{"kind":"Field","name":{"kind":"Name","value":"renewalDate"}},{"kind":"Field","name":{"kind":"Name","value":"currentAgreementPaymentSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"currentAgreementMsrp"}},{"kind":"Field","name":{"kind":"Name","value":"autoPay"}},{"kind":"Field","name":{"kind":"Name","value":"lastPaymentDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastPaymentAmount"}},{"kind":"Field","name":{"kind":"Name","value":"currentBalanceFormula"}},{"kind":"Field","name":{"kind":"Name","value":"billingDaysPastDue"}},{"kind":"Field","name":{"kind":"Name","value":"billToNationalAccount"}},{"kind":"Field","name":{"kind":"Name","value":"nationalAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"isHealthChampion"}},{"kind":"Field","name":{"kind":"Name","value":"mailingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MyOutstandingAwpMembersQuery, MyOutstandingAwpMembersQueryVariables>;
export const MyPastDueMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyPastDueMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myPastDueMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"mdvipId"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"memberSince"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"memberStatus"}},{"kind":"Field","name":{"kind":"Name","value":"lastAwpDate"}},{"kind":"Field","name":{"kind":"Name","value":"renewalDate"}},{"kind":"Field","name":{"kind":"Name","value":"currentAgreementPaymentSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"currentAgreementMsrp"}},{"kind":"Field","name":{"kind":"Name","value":"autoPay"}},{"kind":"Field","name":{"kind":"Name","value":"lastPaymentDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastPaymentAmount"}},{"kind":"Field","name":{"kind":"Name","value":"currentBalanceFormula"}},{"kind":"Field","name":{"kind":"Name","value":"billingDaysPastDue"}},{"kind":"Field","name":{"kind":"Name","value":"billToNationalAccount"}},{"kind":"Field","name":{"kind":"Name","value":"nationalAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"isHealthChampion"}},{"kind":"Field","name":{"kind":"Name","value":"salutation"}},{"kind":"Field","name":{"kind":"Name","value":"mailingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agingCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"aging30"}},{"kind":"Field","name":{"kind":"Name","value":"aging60"}},{"kind":"Field","name":{"kind":"Name","value":"aging90"}},{"kind":"Field","name":{"kind":"Name","value":"aging120"}},{"kind":"Field","name":{"kind":"Name","value":"ccDeclineCall"}},{"kind":"Field","name":{"kind":"Name","value":"ccDeclineLetter"}},{"kind":"Field","name":{"kind":"Name","value":"dunCall1"}},{"kind":"Field","name":{"kind":"Name","value":"dunCall2"}},{"kind":"Field","name":{"kind":"Name","value":"dunCall3"}},{"kind":"Field","name":{"kind":"Name","value":"dunCall4"}},{"kind":"Field","name":{"kind":"Name","value":"dunLetter1"}},{"kind":"Field","name":{"kind":"Name","value":"dunLetter2"}},{"kind":"Field","name":{"kind":"Name","value":"dunLetter3"}},{"kind":"Field","name":{"kind":"Name","value":"dunLetter4"}},{"kind":"Field","name":{"kind":"Name","value":"dunEmail1"}},{"kind":"Field","name":{"kind":"Name","value":"dunEmail2"}},{"kind":"Field","name":{"kind":"Name","value":"dunEmail3"}},{"kind":"Field","name":{"kind":"Name","value":"dunEmail4"}},{"kind":"Field","name":{"kind":"Name","value":"lastCancelReason"}}]}}]}}]}}]} as unknown as DocumentNode<MyPastDueMembersQuery, MyPastDueMembersQueryVariables>;
export const MyPracticeMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyPracticeMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MyPracticeMembersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myPracticeMembers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"mdvipId"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<MyPracticeMembersQuery, MyPracticeMembersQueryVariables>;
export const MyRecommendedOutreachMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyRecommendedOutreachMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myRecommendedOutreachMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"mdvipId"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"memberSince"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"memberStatus"}},{"kind":"Field","name":{"kind":"Name","value":"lastAwpDate"}},{"kind":"Field","name":{"kind":"Name","value":"renewalDate"}},{"kind":"Field","name":{"kind":"Name","value":"currentAgreementPaymentSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"currentAgreementMsrp"}},{"kind":"Field","name":{"kind":"Name","value":"autoPay"}},{"kind":"Field","name":{"kind":"Name","value":"lastPaymentDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastPaymentAmount"}},{"kind":"Field","name":{"kind":"Name","value":"currentBalanceFormula"}},{"kind":"Field","name":{"kind":"Name","value":"billingDaysPastDue"}},{"kind":"Field","name":{"kind":"Name","value":"billToNationalAccount"}},{"kind":"Field","name":{"kind":"Name","value":"nationalAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"isHealthChampion"}},{"kind":"Field","name":{"kind":"Name","value":"salutation"}}]}}]}}]}}]} as unknown as DocumentNode<MyRecommendedOutreachMembersQuery, MyRecommendedOutreachMembersQueryVariables>;
export const MyScholarshipMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyScholarshipMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myScholarshipMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"mdvipId"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"memberSince"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"memberStatus"}},{"kind":"Field","name":{"kind":"Name","value":"lastAwpDate"}},{"kind":"Field","name":{"kind":"Name","value":"renewalDate"}},{"kind":"Field","name":{"kind":"Name","value":"currentAgreementPaymentSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"billToNationalAccount"}},{"kind":"Field","name":{"kind":"Name","value":"isHealthChampion"}},{"kind":"Field","name":{"kind":"Name","value":"nextBirthday"}},{"kind":"Field","name":{"kind":"Name","value":"insuranceName"}},{"kind":"Field","name":{"kind":"Name","value":"scholarshipEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"mailingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MyScholarshipMembersQuery, MyScholarshipMembersQueryVariables>;
export const MySuspendedMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MySuspendedMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mySuspendedMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"mdvipId"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"memberSince"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"memberStatus"}},{"kind":"Field","name":{"kind":"Name","value":"lastAwpDate"}},{"kind":"Field","name":{"kind":"Name","value":"renewalDate"}},{"kind":"Field","name":{"kind":"Name","value":"currentAgreementPaymentSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"currentAgreementMsrp"}},{"kind":"Field","name":{"kind":"Name","value":"autoPay"}},{"kind":"Field","name":{"kind":"Name","value":"lastPaymentDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastPaymentAmount"}},{"kind":"Field","name":{"kind":"Name","value":"currentBalanceFormula"}},{"kind":"Field","name":{"kind":"Name","value":"billingDaysPastDue"}},{"kind":"Field","name":{"kind":"Name","value":"billToNationalAccount"}},{"kind":"Field","name":{"kind":"Name","value":"nationalAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"isHealthChampion"}},{"kind":"Field","name":{"kind":"Name","value":"agingCurrent"}},{"kind":"Field","name":{"kind":"Name","value":"aging30"}},{"kind":"Field","name":{"kind":"Name","value":"aging60"}},{"kind":"Field","name":{"kind":"Name","value":"aging90"}},{"kind":"Field","name":{"kind":"Name","value":"aging120"}}]}}]}}]}}]} as unknown as DocumentNode<MySuspendedMembersQuery, MySuspendedMembersQueryVariables>;
export const MyUpcomingRenewalMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyUpcomingRenewalMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myUpcomingRenewalMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"mdvipId"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"memberSince"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"mobilePhone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"memberStatus"}},{"kind":"Field","name":{"kind":"Name","value":"lastAwpDate"}},{"kind":"Field","name":{"kind":"Name","value":"renewalDate"}},{"kind":"Field","name":{"kind":"Name","value":"currentAgreementPaymentSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"currentAgreementMsrp"}},{"kind":"Field","name":{"kind":"Name","value":"autoPay"}},{"kind":"Field","name":{"kind":"Name","value":"lastPaymentDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastPaymentAmount"}},{"kind":"Field","name":{"kind":"Name","value":"currentBalanceFormula"}},{"kind":"Field","name":{"kind":"Name","value":"billingDaysPastDue"}},{"kind":"Field","name":{"kind":"Name","value":"billToNationalAccount"}},{"kind":"Field","name":{"kind":"Name","value":"nationalAccountName"}},{"kind":"Field","name":{"kind":"Name","value":"isHealthChampion"}},{"kind":"Field","name":{"kind":"Name","value":"mailingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MyUpcomingRenewalMembersQuery, MyUpcomingRenewalMembersQueryVariables>;
export const ClevelandHeartLabSessionUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ClevelandHeartLabSessionUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clevelandHeartlabSessionUrl"}}]}}]} as unknown as DocumentNode<ClevelandHeartLabSessionUrlQuery, ClevelandHeartLabSessionUrlQueryVariables>;